<!--
888888b.                     888             888 888 d8b
888  "88b                    888             888 888 Y8P
888  .88P                    888             888 888
8888888K.   .d88b.  .d8888b  888888  .d88b.  888 888 888 88888b.   .d88b.
888  "Y88b d8P  Y8b 88K      888    d8P  Y8b 888 888 888 888 "88b d88P"88b
888    888 88888888 "Y8888b. 888    88888888 888 888 888 888  888 888  888
888   d88P Y8b.          X88 Y88b.  Y8b.     888 888 888 888  888 Y88b 888
8888888P"   "Y8888   88888P'  "Y888  "Y8888  888 888 888 888  888  "Y88888
                                                                       888
                                                                  Y8b d88P
                                                                   "Y88P"
-->

<template>
  <v-container
      id="bestelling-container"
      class="fill-height"
      style="align-items: flex-start;"
      fluid
  >
    <v-card style="width:100%;">
      <v-card-title>
        <!--

        888b     d888          d8b                88888888888                   888 888
        8888b   d8888          Y8P                    888                       888 888
        88888b.d88888                                 888                       888 888
        888Y88888P888  8888b.  888 88888b.            888      .d88b.   .d88b.  888 88888b.   8888b.  888d888
        888 Y888P 888     "88b 888 888 "88b           888     d88""88b d88""88b 888 888 "88b     "88b 888P"
        888  Y8P  888 .d888888 888 888  888           888     888  888 888  888 888 888  888 .d888888 888
        888   "   888 888  888 888 888  888           888     Y88..88P Y88..88P 888 888 d88P 888  888 888
        888       888 "Y888888 888 888  888           888      "Y88P"   "Y88P"  888 88888P"  "Y888888 888

        -->

        <!--            class="mx-n4"-->
        <v-toolbar
            id="main-toolbar"
            :dense="appGuiCompact || $vuetify.breakpoint.smAndDown"
            flat
        >
          <!--

          88888888888 d8b 888             888
              888     Y8P 888             888
              888         888             888
              888     888 888888  .d88b.  888
              888     888 888    d8P  Y8b 888
              888     888 888    88888888 888
              888     888 Y88b.  Y8b.     888
              888     888  "Y888  "Y8888  888
          -->

          <v-toolbar-title
              id="bestelling"
              class="mr-2 hidden-md-and-down"
          >Bestelling
          </v-toolbar-title>

          <v-divider
              class="mx-1 hidden-md-and-down"
              inset
              vertical
          ></v-divider>

          <!--
          888                                                888 888
          888                                                888 888
          888                                                888 888
          888       .d88b.   .d88b.  .d8888b         8888b.  888 888  .d88b.  .d8888b
          888      d8P  Y8b d8P  Y8b 88K                "88b 888 888 d8P  Y8b 88K
          888      88888888 88888888 "Y8888b.       .d888888 888 888 88888888 "Y8888b.
          888      Y8b.     Y8b.          X88       888  888 888 888 Y8b.          X88
          88888888  "Y8888   "Y8888   88888P'       "Y888888 888 888  "Y8888   88888P'
          -->

          <!-- Knop: Lees alles    -->
          <v-tooltip
              id="lees_alles"
              open-delay="1000"
              bottom
          >
            <template v-slot:activator="{ on, attrs}">
              <!--              TODO: data loader-->
              <v-badge
                  v-model="GET_TIPS"
                  overlap
                  left
                  offset-x="4em"
                  content="Lees alles"
                  color="secondary darken-2"
              >
                <!--            class="ml-8"-->
                <v-btn
                    @click="m_LoadSnelStartData"
                    :loading="ss_GetGlobalProgressFlag"
                    :disabled="!user_GetCurrentSnelStart || ss_GetGlobalProgressFlag"
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="mx-2 hidden-sm-and-down"
                    :large="!appGuiCompact && $vuetify.breakpoint.mdAndUp"
                >
                  <v-icon :large="!appGuiCompact && $vuetify.breakpoint.mdAndUp">mdi-database-refresh</v-icon>
                </v-btn>
              </v-badge>
            </template>
            <span>Lees alles opnieuw</span>
          </v-tooltip>

          <!--      BEDRIJF/ADRESS  -->

          <!--
          888888b.                 888         d8b    d8b  .d888               d8888      888
          888  "88b                888         Y8P    Y8P d88P"               d88888      888
          888  .88P                888                    888                d88P888      888
          8888888K.   .d88b.   .d88888 888d888 888   8888 888888            d88P 888  .d88888 888d888  .d88b.  .d8888b
          888  "Y88b d8P  Y8b d88" 888 888P"   888   "888 888              d88P  888 d88" 888 888P"   d8P  Y8b 88K
          888    888 88888888 888  888 888     888    888 888    888888   d88P   888 888  888 888     88888888 "Y8888b.
          888   d88P Y8b.     Y88b 888 888     888    888 888            d8888888888 Y88b 888 888     Y8b.          X88
          8888888P"   "Y8888   "Y88888 888     888    888 888           d88P     888  "Y88888 888      "Y8888   88888P'
                                                      888
                                                     d88P
                                                   888P"
          -->
          <v-col
              id="bedrijf"
              :cols="$vuetify.breakpoint.mdAndDown ? 4: 2"
              class="mx-0"
              v-show="!settingsBedrijf.hideWidget || comp_FilterKlantenMetConfiguratie.length > 1"
          >
            <!--                  :disabled="previewMode || comp_FilteredVerkoopOrders.length === 0"-->
            <!--                  :label="comp_FilteredVerkoopOrders.length !== 0 ? 'Laad de laatste order' : 'Geen orders'"-->
            <!--                  @change="m_VoegLaatsteOrderInBasket"-->
            <v-row>
              <v-text-field
                  class="mb-n6 caption"
                  label="Bedrijf / contact"
                  v-model="comp_FilterKlantenMetConfiguratie[0].naam"
                  v-if="comp_FilterKlantenMetConfiguratie.length === 1"
                  readonly
                  :dense="appGuiCompact || $vuetify.breakpoint.smAndDown"
              ></v-text-field>

              <v-combobox
                  v-model="bedrijfLijstSelected"
                  v-if="comp_FilterKlantenMetConfiguratie.length !== 1"
                  :search-input.sync="bedrijfInput"
                  :items="comp_MenuKlanten"
                  :disabled="!comp_MenuKlanten.length"
                  label="Bedrijf / contact"
                  class="mb-n6 caption"
                  :dense="appGuiCompact || $vuetify.breakpoint.smAndDown"
              ></v-combobox>
            </v-row>
            <v-row
                v-if="ss_GetKlantenProgress.loading || false"
            >
              <v-progress-linear
                  class="mt-2"
                  :value="ss_GetKlantenProgress.procent"
                  height="1"
                  color="error"
                  striped
              ></v-progress-linear>
            </v-row>
          </v-col>

          <!--
           .d8888b.     d8b          888      888
          d88P  Y88b    Y8P          888      888
          Y88b.                      888      888
           "Y888b.     8888  8888b.  88888b.  888  .d88b.   .d88b.  88888b.
              "Y88b.   "888     "88b 888 "88b 888 d88""88b d88""88b 888 "88b
                "888    888 .d888888 888  888 888 888  888 888  888 888  888
          Y88b  d88P    888 888  888 888 d88P 888 Y88..88P Y88..88P 888  888
           "Y8888P"     888 "Y888888 88888P"  888  "Y88P"   "Y88P"  888  888
                        888
                       d88P
                     888P"
          -->

          <!--              class="hidden-md-and-down"-->
          <v-menu
              id="sjabloon-menu"
              rounded="b-xl"
              offset-y
              v-if="!(comp_FilteredSjablonen.length === 1 && settingsSjabloon.hideWidget)"
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-tooltip
                  open-delay="1000"
                  bottom
              >
                <template v-slot:activator="{ on: tooltip }">
                  <v-badge
                      v-model="GET_TIPS"
                      content="Order sjabloon"
                      overlap
                      left
                      offset-x="6em"
                      color="info darken-2"
                  >
                    <v-btn
                        class="white--text mx-2"
                        color="info"
                        v-bind="attrs"
                        v-on="{ ...tooltip, ...menu }"
                        :loading="ss_GetSjablonenProgress.loading"
                        :large="!appGuiCompact && $vuetify.breakpoint.mdAndUp"
                    >
                      <v-icon
                          v-if="comp_CurrentSjabloonName === 'Leeg'"
                          :large="!appGuiCompact && $vuetify.breakpoint.mdAndUp"
                      >mdi-file-outline
                      </v-icon>
                      <v-icon
                          v-else
                          :large="!appGuiCompact && $vuetify.breakpoint.mdAndUp"
                      >mdi-file-document-outline
                      </v-icon>

                      <!--                    <span-->
                      <!--                        class="hidden-md-and-down"-->
                      <!--                    >{{ comp_CurrentSjabloonName }}</span>-->
                    </v-btn>
                  </v-badge>
                </template>
                <span>Sjabloon: {{ comp_CurrentSjabloonName }}</span>
              </v-tooltip>
            </template>

            <v-list>
              <v-list-item
                  v-for="item in comp_FilteredSjablonen"
                  :key="item.id"
                  link
                  @click="prop_CurrentSjabloonID = item.id"
              >
                <!--      :disabled="item.disabled"-->
                <v-list-item-subtitle
                    :class="{'font-weight-bold': item.id === prop_CurrentSjabloonID}"
                    v-text="item.omschrijving"
                ></v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-menu>

          <!--
           .d88888b.               888                                 888             888
          d88P" "Y88b              888                                 888             888
          888     888              888                                 888             888
          888     888 888d888  .d88888  .d88b.  888d888       .d8888b  888888  8888b.  888888 888  888 .d8888b
          888     888 888P"   d88" 888 d8P  Y8b 888P"         88K      888        "88b 888    888  888 88K
          888     888 888     888  888 88888888 888           "Y8888b. 888    .d888888 888    888  888 "Y8888b.
          Y88b. .d88P 888     Y88b 888 Y8b.     888                X88 Y88b.  888  888 Y88b.  Y88b 888      X88
           "Y88888P"  888      "Y88888  "Y8888  888            88888P'  "Y888 "Y888888  "Y888  "Y88888  88888P'
          -->

          <!--      MENU: ORDER PROCESS STATUS -->
          <!--          len={{comp_ProcessStatusFiltered.length}} hide={{settingsProcessStatus.hideWidget}}-->
          <v-menu
              id="process-status"
              v-if="!(comp_ProcessStatusFiltered.length === 1 && settingsProcessStatus.hideWidget)"
              rounded="b-xl"
              offset-y
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-tooltip
                  open-delay="1000"
                  bottom
              >
                <template v-slot:activator="{ on: tooltip }">
                  <v-badge
                      v-model="GET_TIPS"
                      content="Process status"
                      overlap
                      color="primary darken-2"
                      left
                      offset-x="7em"
                  >
                    <v-btn
                        class="white--text mx-2 caption"
                        color="primary"
                        v-bind="attrs"
                        v-on="{ ...tooltip, ...menu }"
                        :large="!appGuiCompact && $vuetify.breakpoint.mdAndUp"
                    >
                      <v-icon
                          class="mx-1"
                          :large="!appGuiCompact && $vuetify.breakpoint.mdAndUp"
                      >{{ comp_CurrentProcessStatus.icon }}
                      </v-icon>
                      <span
                          class="hidden-md-and-down text-caption"
                          v-if="!settingsProcessStatus.hideOmschrijving"
                      >{{ prop_ProcessStatusName }}</span>
                    </v-btn>
                  </v-badge>
                </template>
                <!--      Tooltip text-->
                <span>Process status: {{ prop_ProcessStatusName }}</span>
              </v-tooltip>
            </template>
            <v-list>
              <v-list-item
                  v-for="item in comp_ProcessStatusFiltered"
                  :key="item.id"
                  :disabled="item.disabled"
                  link
                  @click="prop_ProcessStatusName = item.text"
              >
                <v-icon class="mr-2">
                  {{ item.icon }}
                </v-icon>
                <v-list-item-title
                    v-text="item.text"
                    :class="{'font-weight-bold': prop_ProcessStatusName === item.text}"
                ></v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <!--
          888888b.                     888             888 888 d8b                         888
          888  "88b                    888             888 888 Y8P                         888
          888  .88P                    888             888 888                             888
          8888888K.   .d88b.  .d8888b  888888  .d88b.  888 888 888 88888b.   .d88b.        888  888 88888b.   .d88b.  88888b.
          888  "Y88b d8P  Y8b 88K      888    d8P  Y8b 888 888 888 888 "88b d88P"88b       888 .88P 888 "88b d88""88b 888 "88b
          888    888 88888888 "Y8888b. 888    88888888 888 888 888 888  888 888  888       888888K  888  888 888  888 888  888
          888   d88P Y8b.          X88 Y88b.  Y8b.     888 888 888 888  888 Y88b 888       888 "88b 888  888 Y88..88P 888 d88P
          8888888P"   "Y8888   88888P'  "Y888  "Y8888  888 888 888 888  888  "Y88888       888  888 888  888  "Y88P"  88888P"
                                                                                 888                                  888
                                                                            Y8b d88P                                  888
                                                                             "Y88P"                                   888
          -->

          <!--
           .88888.                 dP                                                       dP
          d8'   `8b                88                                                       88
          88     88 88d888b. .d888b88 .d8888b. 88d888b.    d888888b .d8888b. 88d888b. .d888b88 .d8888b. 88d888b.
          88     88 88'  `88 88'  `88 88ooood8 88'  `88       .d8P' 88ooood8 88'  `88 88'  `88 88ooood8 88'  `88
          Y8.   .8P 88       88.  .88 88.  ... 88           .Y8P    88.  ... 88    88 88.  .88 88.  ... 88    88
           `8888P'  dP       `88888P8 `88888P' dP          d888888P `88888P' dP    dP `88888P8 `88888P' dP    dP

                dP oo          dP
                88             88
          .d888b88 dP .d8888b. 88 .d8888b. .d8888b.
          88'  `88 88 88'  `88 88 88'  `88 88'  `88
          88.  .88 88 88.  .88 88 88.  .88 88.  .88
          `88888P8 dP `88888P8 dP `88888P' `8888P88
                                                .88
                                            d8888P
          -->
          <v-dialog id="OrderDialog"
                    v-model="orderDialog"
                    width="70vw"
          >
            <v-card>
              <v-toolbar
                  color="primary"
                  flat
                  dark
                  :dense="appGuiCompact"
              >
                <v-toolbar-title>
                  <v-icon large>mdi-cube-send</v-icon>
                  <span
                      class="hidden-md-and-down mx-2"
                  >Order zenden</span>
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn
                    class="mx-4"
                    color="error"
                    @click="m_CleanBasket(); orderDialog = false"
                    :disabled="comp_ArtikelenInBasket.length === 0"
                >
                  {{
                    ($vuetify.breakpoint.mdAndUp ? "De bestelling " : "") + ($vuetify.breakpoint.smAndUp ? "annuleren" : "")
                  }}
                  <v-icon class="ml-2" left>mdi-cancel</v-icon>
                </v-btn>
                <v-btn
                    @click="orderDialog = false"
                    outlined
                >{{ $vuetify.breakpoint.smAndUp ? "Later" : "" }}
                  <v-icon class="ml-2" left>mdi-pause</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text
                  v-if="bedrijfLijstSelected"
                  class="mt-4 text-h5"
              >Klant: {{ bedrijfLijstSelected.naam }}
              </v-card-text>
<!--              <v-card-text-->
<!--                  v-else-->
<!--                  class="mt-4 text-h5 error&#45;&#45;text"-->
<!--              >Geen klant-->
<!--              </v-card-text>-->

              <v-simple-table
                  v-if="comp_ArtikelenInBasket.length > 0"
                  class="mx-6 overflow-auto"
                  style="max-height: 30vh"
                  dense
              >
                <thead>
                <tr>
                  <th>#</th>
                  <th class="text-left">Artikelcode</th>
                  <th class="text-left">Omschrijving</th>
                  <th class="text-left">Aantal</th>
                  <th class="text-left">
                  {{ comp_ArtikelenInBasket.length }}
                    regel{{ comp_ArtikelenInBasket.length > 1 ? "s" : "" }}
                  </th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(previewArtikel, index) in comp_ArtikelenInBasket"
                    :key="previewArtikel.artikelcode"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ previewArtikel.artikelcode }}</td>
                  <td>{{ previewArtikel.omschrijving }}</td>
                  <td>{{ previewArtikel.basket }}
                    <span
                        class="text-caption"
                    >{{ previewArtikel.eenheid }}
                    </span>
                  </td>
                  <td class="text-left">
                    <v-btn
                        @click.stop="m_MinOneArtikel(previewArtikel)"
                        color="warning"
                        x-small
                    >
                      <v-icon
                          small
                      >mdi-minus
                      </v-icon>
                    </v-btn>
                    <!--PLUS-->
                    <v-btn
                        color="secondary"
                        class="mx-2"
                        @click.stop="m_PlusOneArtikel(previewArtikel)"
                        x-small
                    >
                      <v-icon
                          small
                      >mdi-plus
                      </v-icon>
                    </v-btn>
                  </td>
                  <td class="text-left">
                    <v-btn
                        @click.stop="m_ClearArtikelItem(previewArtikel)"
                        color="error"
                        x-small
                    >
                      <v-icon
                          small
                      >mdi-trash-can-outline
                      </v-icon>
                    </v-btn>
                  </td>
                </tr>
                </tbody>
              </v-simple-table>

              <v-card-subtitle
                  class="mt-6 mx-8"
                  v-else
              >Geen artikelen...
              </v-card-subtitle>

              <v-divider
                  class="my-2 mx-4"
              ></v-divider>

              <v-card-text>
                <v-form>
                  <v-container>
                    <v-row class="my-2">
                      <!--  OMSCHRIJVING VELD -->
                      <v-text-field
                          v-model="orderOmschrijving"
                          label="Omschrijving"
                          counter="50"
                          maxlength="50"
                          clearable
                          persistent-placeholder
                          :placeholder="settingsAlgemeen.defaultOrderOmschrijving"
                          filled
                          :color="getControlGUIColor()"
                          :dense="appGuiCompact"
                          @keydown.enter.prevent="m_orderFocus2Memo"
                      ></v-text-field>
                    </v-row>

                    <v-row>
                      <!--  ORDER MEMO VELD -->
                      <v-textarea
                          ref="order-dialog-memo"
                          v-model="orderMemo"
                          label="Opmerkingen"
                          counter="2048"
                          :dense="appGuiCompact"
                          clearable
                          filled
                          :color="getControlGUIColor()"
                      ></v-textarea>

                      <!--    SIGN ACTIVATIE KNOP -->
                      <v-btn
                          v-if="!signNeed && settingsSignature.signPadShow"
                          @click="signNeed = true"
                          fab
                          color="primary"
                          class="ml-4"
                      >
                        <v-icon>mdi-file-sign</v-icon>
                      </v-btn>

                      <!--    TOOLS BUTTON -->
                      <v-card
                          v-show="signNeed && settingsSignature.signPadShow"
                          elevation="0"
                          class="box ml-6"
                      >
                        <v-card-title
                            v-show="signNeed"
                            class="align-content-start ma-0 pa-0 hidden-md-and-down"
                        >
                          <v-icon>mdi-draw</v-icon>
                        </v-card-title>

                        <v-fab-transition>
                          <v-speed-dial
                              v-show="signNeed"
                              v-model="signToolFab"
                              absolute
                              top
                              right
                              direction="left"
                              class="mt-n4 mr-n1"
                              transition="v-slide-x-transition"
                          >
                            <template v-slot:activator>
                              <v-btn
                                  v-model="signToolFab"
                                  color="accent"
                                  fab
                              >
                                <v-icon>{{ signToolFab ? 'mdi-close-circle-outline' : 'mdi-tools' }}</v-icon>
                              </v-btn>
                            </template>

                            <!--UNDO  -->
                            <v-btn
                                fab
                                light
                                small
                                color="warning"
                                @click="$refs.signaturePad.undoSignature()"
                                :disabled="isEmptySignPad()"
                            >
                              <v-icon>mdi-undo</v-icon>
                            </v-btn>

                            <!--BLUE PEN  -->
                            <!--                            <v-btn-->
                            <!--                                fab-->
                            <!--                                light-->
                            <!--                                small-->
                            <!--                                @click="padOptions.penColor = $refs.signaturePad.signaturePad.penColor = '#006B88'"-->
                            <!--                            >-->
                            <!--                              <v-icon-->
                            <!--                                  color="#006B88"-->
                            <!--                              >mdi-draw-pen-->
                            <!--                              </v-icon>-->
                            <!--                            </v-btn>-->

                            <!--RED PEN -->
                            <!--                            <v-btn-->
                            <!--                                fab-->
                            <!--                                light-->
                            <!--                                small-->
                            <!--                                @click="padOptions.penColor = $refs.signaturePad.signaturePad.penColor = '#AC3235'"-->
                            <!--                            >-->
                            <!--                              <v-icon-->
                            <!--                                  color="#AC3235"-->
                            <!--                              >mdi-draw-pen-->
                            <!--                              </v-icon>-->
                            <!--                            </v-btn>-->

                            <!--BLACK PEN -->
                            <!--                            <v-btn-->
                            <!--                                fab-->
                            <!--                                light-->
                            <!--                                small-->
                            <!--                                @click="padOptions.penColor = $refs.signaturePad.signaturePad.penColor = '#06080F'"-->
                            <!--                            >-->
                            <!--                              <v-icon-->
                            <!--                                  color="#06080F"-->
                            <!--                              >mdi-draw-pen-->
                            <!--                              </v-icon>-->
                            <!--                            </v-btn>-->

                            <!--ERASE -->
                            <v-btn
                                fab
                                light
                                small
                                color="error"
                                @click="clearSignPad"
                                :disabled="isEmptySignPad()"
                            >
                              <v-icon>mdi-eraser</v-icon>
                            </v-btn>

                          </v-speed-dial>
                        </v-fab-transition>

                        <!--CLOSE -->
                        <v-fab-transition>
                          <v-btn
                              v-show="signNeed"
                              @click="signNeed = false"
                              light
                              icon
                              small
                              absolute
                              class="ma-1"
                          >
                            <v-icon
                                small
                            >mdi-close
                            </v-icon>
                          </v-btn>
                        </v-fab-transition>

                        <!--SIGN PAD  -->
                        <VueSignaturePad
                            v-show="signNeed"
                            id="signature"
                            ref="signaturePad"
                            :options="padOptions"
                            width="500px"
                            height="250px"
                        />
                      </v-card>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    @click="m_OrderZenden"
                    :loading="inProgressSend"
                    color="secondary"
                    :disabled="comp_ArtikelenInBasket.length === 0"
                >
<!--                    :disabled="!bedrijfLijstSelected || comp_ArtikelenInBasket.length === 0"-->
                  Order zenden
                  <v-icon
                      class="ml-2"
                  >mdi-send-check
                  </v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!--      RONDE Knop: Bestellen   -->

          <v-tooltip id="bestellen"
                     open-delay="1000"
                     bottom
          >
            <template v-slot:activator="{ on, attrs}">
              <!--                  :disabled="inProgress || selectedAboTermijn.index === -1 || !filteredAbonnementen.length"-->
              <v-badge
                  v-model="GET_TIPS"
                  content="Verzend de bestelling"
                  overlap
                  left
                  offset-x="3em"
                  color="accent darken-2"
              >
                <v-badge
                    :content="comp_BasketCount"
                    :value="comp_BasketCount !== 0"
                    color="error"
                    overlap
                    offset-x="2em"
                >
                  <!--                    bordered-->
                  <!--                class="mx-2"-->
                  <v-btn
                      @click="orderDialog=true"
                      :disabled="comp_BasketCount === 0 || inProgressSend"
                      v-bind="attrs"
                      v-on="on"
                      fab
                      :loading="inProgressSend"
                      :x-large="!appGuiCompact && $vuetify.breakpoint.mdAndUp"
                      :large="appGuiCompact || $vuetify.breakpoint.smAndDown"
                      color="accent"
                  >
                    <v-icon>mdi-basket-check-outline</v-icon>
                  </v-btn>
                </v-badge>
              </v-badge>
            </template>
            <span>Zend order in SnelStart</span>
          </v-tooltip>

          <!--
           .d8888b.           888    888    d8b                                  888               888    888
          d88P  Y88b          888    888    Y8P                                  888               888    888
          Y88b.               888    888                                         888               888    888
           "Y888b.    .d88b.  888888 888888 888 88888b.   .d88b.  .d8888b        88888b.  888  888 888888 888888  .d88b.  88888b.
              "Y88b. d8P  Y8b 888    888    888 888 "88b d88P"88b 88K            888 "88b 888  888 888    888    d88""88b 888 "88b
                "888 88888888 888    888    888 888  888 888  888 "Y8888b.       888  888 888  888 888    888    888  888 888  888
          Y88b  d88P Y8b.     Y88b.  Y88b.  888 888  888 Y88b 888      X88       888 d88P Y88b 888 Y88b.  Y88b.  Y88..88P 888  888
           "Y8888P"   "Y8888   "Y888  "Y888 888 888  888  "Y88888  88888P'       88888P"   "Y88888  "Y888  "Y888  "Y88P"  888  888
                                                              888
                                                         Y8b d88P
                                                          "Y88P"
          -->

          <v-badge id="instellingen"
                   v-model="GET_TIPS"
                   content="Instellingen"
                   color="grey"
                   offset-x="2em"
                   v-if="settingsAlgemeen.showBestelformulierInstellingen"
          >
            <!--    overlap   -->
            <!--    color="accent darken-2"   -->
            <v-btn
                @click="settingsDialogModel = !settingsDialogModel"
                id="instellingen-btn"
                class="ml-4 hidden-sm-and-down"
                :large="!appGuiCompact"
                icon
            >
              <!--    :disabled="comp_GlobalProgress"   -->
              <v-icon
                  :large="!appGuiCompact"
              >mdi-cog
              </v-icon>
            </v-btn>
          </v-badge>

          <!--          Eind hoofd toolbar        -->
        </v-toolbar>
      </v-card-title>
      <!--

8888888b.         d8888 88888888888      d8888       88888888888      d8888 888888b.   8888888888 888
888  "Y88b       d88888     888         d88888           888         d88888 888  "88b  888        888
888    888      d88P888     888        d88P888           888        d88P888 888  .88P  888        888
888    888     d88P 888     888       d88P 888           888       d88P 888 8888888K.  8888888    888
888    888    d88P  888     888      d88P  888           888      d88P  888 888  "Y88b 888        888
888    888   d88P   888     888     d88P   888           888     d88P   888 888    888 888        888
888  .d88P  d8888888888     888    d8888888888           888    d8888888888 888   d88P 888        888
8888888P"  d88P     888     888   d88P     888           888   d88P     888 8888888P"  8888888888 88888888

      -->

      <!--    DATA TABLE    -->
      <!--          :pagination="dataTablePagination"-->
      <!--          :custom-filter="m_ArtikelenDataTableCustomSearch"-->
      <v-data-table
          id="tabel"
          ref="main-artikel-table"
          :headers="comp_mainTableHeader"
          :items="comp_ArtikelenToolbarFiltersEnZoeken"
          :dense="appGuiCompact"
          :page.sync="dataTablePage"
          :search="comp_extendedSearch ? '' : searchDelay"
          sort-by="omschrijving"
          class="elevation-0"
          :items-per-page.sync="dataTableItemsPerPage"
          :footer-props="settingsFooterTable"
          item-key="id"
          @click:row="m_EditArtikelItem"
          :loading="ss_GetArtikelenProgress.loading"
          loading-text="Laden..."
          mobile-breakpoint="700"
          locale="NL-nl"
          single-expand
          :expanded.sync="mainTableExpandedFormExpandedList"
          :show-expand="settingsExpandForm.show"
      >
        <!--    height="68vh"   -->
        <!--    Progress counter (is / van)   -->
        <template v-slot:progress>
          <!--    :value="ss_GetArtikelenProgress.loading & ss_GetArtikelenProgress.apiTotal"   -->
          <v-tooltip
              :value="ss_GetArtikelenProgress.loading && ss_GetArtikelenProgress.apiTotal > 0"
              close-delay="120000"
              color="secondary"
              top
          >
            <template v-slot:activator="{ on }">
              <v-progress-linear
                  :value="ss_GetArtikelenProgress.procent"
                  height="2"
                  v-on="on"
                  color="light-blue"
                  striped
              >
                <!--{{ ss_GetArtikelenProgress.apiCount }} / {{ ss_GetArtikelenProgress.apiTotal }}-->
              </v-progress-linear>
            </template>
            {{ ss_GetArtikelenProgress.apiCount }} / {{ ss_GetArtikelenProgress.apiTotal }}
          </v-tooltip>
        </template>

        <!--    EXPAND FORM   -->
        <template v-slot:expanded-item="{ headers, item }">
          <td
              :colspan="headers.length"
              style="padding: 0"
          >
            <v-card
                v-if="settingsExpandForm.show"
                class="mx-0 mb-4 mt-1"
                elevation="0"
            >
              <v-card-title
                  v-if="settingsExpandForm.titel"
              >
                {{ settingsExpandForm.titel }}
              </v-card-title>

              <v-form
                  v-model="mainTableExpandedFormModel"
                  v-if="settingsExpandForm.fields"
                  class="mx-4"
              >
                <v-row>
                  <v-col
                      v-for="field in [...settingsExpandForm.fields].filter(v => !v.hide)"
                      :key="field.label || field.model"
                      :cols="field.cols || 12"
                      :sm="field.sm || 6"
                      :md="field.md || 4"
                      :lg="field.lg || 3"
                  >
                    <v-text-field
                        v-if="!field.component || field.component === 'v-text-field'"
                        v-model="item[field.model]"
                        :name="field.model"
                        :label="field.label || 'Geen label'"
                        :prefix="field.prefix"
                        readonly
                    ></v-text-field>

                    <v-checkbox
                        v-else-if="field.component === 'v-checkbox'"
                        v-model="item[field.model]"
                        :name="field.model"
                        :label="field.label || 'Geen label'"
                        :prefix="field.prefix"
                        readonly
                    ></v-checkbox>

                    <span
                        v-else
                        style="color: red;"
                    >Component is niet gevonden: {{ field.component }}</span>

                    <!--                    <component-->
                    <!--                        v-else-->
                    <!--                        :is="m_getDefaultComponentName(field.component)"-->
                    <!--                        v-model="item[field.model]"-->
                    <!--                        :name="field.model"-->
                    <!--                        :label="field.label || 'Geen label'"-->
                    <!--                        :prefix="field.prefix"-->
                    <!--                        readonly-->
                    <!--                    ></component>-->
                  </v-col>
                </v-row>
                <!--      https://codepen.io/pen/?editors=1010    -->
              </v-form>
            </v-card>
          </td>
        </template>

        <!--
                88888888888                   888 888
                    888                       888 888
                    888                       888 888
                    888      .d88b.   .d88b.  888 88888b.   8888b.  888d888
                    888     d88""88b d88""88b 888 888 "88b     "88b 888P"
                    888     888  888 888  888 888 888  888 .d888888 888
                    888     Y88..88P Y88..88P 888 888 d88P 888  888 888
                    888      "Y88P"   "Y88P"  888 88888P"  "Y888888 888
        -->

        <!--    Toolbar: Artikelen -->
        <template
            v-slot:top
            id="table-toolbar"
        >
          <!--  class="hidden-md-and-down"  -->
          <v-toolbar
              flat
              id="artikelen"
          >
            <v-toolbar-title
                class="hidden-md-and-down ml-4"
            >Artikelen
            </v-toolbar-title>

            <v-divider
                class="mx-2 hidden-md-and-down"
                inset
                vertical
            ></v-divider>

            <!--
 .88888.                                 dP
d8'   `8b                                88
88     88 88d8b.d8b. d888888b .d8888b. d8888P .d8888b. 88d888b. .d8888b. .d8888b. 88d888b.
88     88 88'`88'`88    .d8P' 88ooood8   88   88'  `88 88'  `88 88'  `88 88ooood8 88'  `88
Y8.   .8P 88  88  88  .Y8P    88.  ...   88   88.  .88 88       88.  .88 88.  ... 88.  .88
 `8888P'  dP  dP  dP d888888P `88888P'   dP   `8888P88 dP       `88888P' `88888P' 88Y888P'
                                                   .88                            88
                                               d8888P                             dP
            -->
            <v-col
                cols="3"
                id="omzetgroep"
                class="hidden-sm-and-down"
                :style="{ maxWidth: appGuiCompact ? '8em' : '10em' }"
                v-if="(!settingsOmzetgroepen.hideWidget || comp_OmzetgroepenFiltered.length > 1) && comp_OmzetgroepenExAll.length > 1"
            >
              <v-select
                  v-model="prop_OmzetgroepID"
                  :items="comp_OmzetgroepenFiltered"
                  :disabled="previewMode"
                  item-value="id"
                  item-text="omschrijving"
                  label="Omzetgroep filter"
                  class="mb-n6 caption"
                  :clearable="prop_OmzetgroepID !== 0 && comp_OmzetgroepenFiltered[0].id === 0"
                  @click:clear="m_clearSelectedOmzetgroep"
                  :dense="appGuiCompact"
              >
                <!--      DropDown List-->
                <template v-slot:item="data">
                  <v-badge
                      :content="m_getOmzetgroepenArtikelenCount(data.item.id)"
                      :value="m_getOmzetgroepenArtikelenCount(data.item.id) !== 0"
                      color="grey"
                      overlap
                      bordered
                  >
                    <v-chip
                        :color="m_getColorFromOmzetgroepID(data.item.id)"
                        text-color="black"
                        :small="appGuiCompact"
                        :class="$vuetify.theme.dark ? 'darken-3' : 'lighten-4'"
                        :disabled="m_getOmzetgroepenArtikelenCount(data.item.id) === 0"
                    >
                      {{ data.item.omschrijving }}
                    </v-chip>
                  </v-badge>
                </template>

              </v-select>
            </v-col>

            <!--
888                        888             888                                         888
888                        888             888                                         888
888                        888             888                                         888
888       8888b.   8888b.  888888 .d8888b  888888  .d88b.         .d88b.  888d888  .d88888  .d88b.  888d888 .d8888b
888          "88b     "88b 888    88K      888    d8P  Y8b       d88""88b 888P"   d88" 888 d8P  Y8b 888P"   88K
888      .d888888 .d888888 888    "Y8888b. 888    88888888       888  888 888     888  888 88888888 888     "Y8888b.
888      888  888 888  888 Y88b.       X88 Y88b.  Y8b.           Y88..88P 888     Y88b 888 Y8b.     888          X88
88888888 "Y888888 "Y888888  "Y888  88888P'  "Y888  "Y8888         "Y88P"  888      "Y88888  "Y8888  888      88888P'
            -->

            <v-tooltip
                id="last_orders"
                open-delay="1000"
                bottom
            >
              <template v-slot:activator="{ on, attrs}">
                <v-badge
                    v-model="GET_TIPS"
                    content="Voeg laatste order"
                    overlap
                    left
                    offset-x="3em"
                    color="warning darken-2"
                >
                  <v-badge
                      :content="ss_GetVerkoopOrdersProgress.loading ? `${ss_GetVerkoopOrdersProgress.apiCount} / ${ss_GetVerkoopOrdersProgress.apiTotal}` : comp_FilteredVerkoopOrders.length"
                      :value="comp_FilteredVerkoopOrders.length > 0 && ss_GetVerkoopOrdersProgress.apiCount !== null"
                      overlap
                      offset-x="2em"
                      color="grey"
                  >
                    <!--              Laatste orders +  -->
                    <v-btn
                        @click="laatsteOrderDialog = true"
                        class="mx-2"
                        :disabled="ss_GetVerkoopOrdersProgress.loading || comp_FilteredVerkoopOrders.length === 0"
                        fab
                        :small="appGuiCompact"
                        color="warning"
                        v-bind="attrs"
                        v-on="on"
                        :loading="ss_GetVerkoopOrdersProgress.loading || laatsteOrderInProgress"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-badge>
                </v-badge>
              </template>
              <span>Voeg laatste verkooporder toe</span>
            </v-tooltip>

            <v-spacer></v-spacer>

            <!--
8888888888          888                            .d888 d8b 888 888
888                 888                           d88P"  Y8P 888 888
888                 888                           888        888 888
8888888    888  888 888888 888d888  8888b.        888888 888 888 888888  .d88b.  888d888 .d8888b
888        `Y8bd8P' 888    888P"       "88b       888    888 888 888    d8P  Y8b 888P"   88K
888          X88K   888    888     .d888888       888    888 888 888    88888888 888     "Y8888b.
888        .d8""8b. Y88b.  888     888  888       888    888 888 Y88b.  Y8b.     888          X88
8888888888 888  888  "Y888 888     "Y888888       888    888 888  "Y888  "Y8888  888      88888P'
            -->

            <v-btn id="toggle-filter"
                   v-if="!settingsFilterInToolbar.hideFilters"
                   fab
                   small
                   class="hidden-sm-and-down"
                   color="accent"
                   @click="settingsFilterInToolbar.visibleFilter = !settingsFilterInToolbar.visibleFilter"
            >
              <v-icon>{{ settingsFilterInToolbar.visibleFilter ? 'mdi-filter' : 'mdi-filter-off' }}</v-icon>
            </v-btn>
            <v-col id="extra-hoofd-filters"
                   v-for="f in settingsFilterInToolbar.filters"
                   :key="f.fieldName"
                   :cols="f.cols || 2"
                   class="hidden-md-and-down"
                   :hidden="!settingsFilterInToolbar.visibleFilter || settingsFilterInToolbar.hideFilters"
            >
              <!--    :items="Array.from(new Set(comp_ArtikelenFromCurAdm.map(item => item[f.fieldName]))).sort()" -->
              <component
                  :is="f.component || 'VSelect'"
                  v-model="f.model"
                  :items="Array.from(new Set(comp_ArtikelenFromCurAdmWithFilter.map(item => item[f.fieldName]))).sort()"
                  :label="f.label"
                  :clearable="f.clearable"
                  :chips="f.chips"
                  :small-chips="f.chips"
                  :deletable-chips="f.chips"
                  :prepend-icon="f.prependIcon"
                  :append-icon="f.appendIcon"
                  :multiple="f.multiple"
                  :dense="appGuiCompact"
                  class="mb-n6 caption"
                  :disabled="previewMode"
              >
                <!--                            <template v-slot:item="data">-->
                <!--                                  <v-badge-->
                <!--                                      :content="m_getArtikelenCountOpField(f.fieldName, data.item)"-->
                <!--                                      :value="m_getArtikelenCountOpField(f.fieldName, data.item) > 0"-->
                <!--                                      color="grey"-->
                <!--                                      overlap-->
                <!--                                      bordered-->
                <!--                                  >-->
                <!--                                    <v-chip-->
                <!--                                        :small="appGuiCompact"-->
                <!--                                        :class="$vuetify.theme.dark ? 'darken-3' : 'lighten-4'"-->
                <!--                                        :-disabled="m_getArtikelenCountOpField(f.fieldName, data.item) === 0"-->
                <!--                                    >-->
                <!--                              {{ data.item }}-->
                <!--                                  - {{ m_getArtikelenCountOpField(f.fieldName, data.item) }}-->
                <!--                                    </v-chip>-->
                <!--                                  </v-badge>-->
                <!--                            </template>-->
              </component>
            </v-col>

            <!--      ZOEK VELD     -->
            <v-badge
                v-model="GET_TIPS"
                content="/ - zoekterm separator"
                overlap
                left
                offset-x="11em"
                offset-y="1%"
                color="primary darken-2"
            >
              <v-text-field
                  id="zoeken"
                  ref="zoeken"
                  v-model="search"
                  :prepend-inner-icon="comp_extendedSearch ? 'mdi-magnify-expand' : 'mdi-magnify'"
                  append-icon="mdi-keyboard-return"
                  label="Zoeken"
                  single-line
                  hide-details
                  clearable
                  autofocus
                  class="shrink mx-2"
                  style="max-width:14em"
                  @keydown.enter="m_inputSearch"
                  @click:clear="searchDelay='';search=''"
                  :background-color="comp_GetSearchColor"
                  :color="getControlGUIColor()"
              ></v-text-field>
            </v-badge>

            <!--            <v-tooltip-->
            <!--                open-delay="1000"-->
            <!--                bottom-->
            <!--            >-->
            <!--              <template v-slot:activator="{ on, attrs}">-->
            <!--                <v-btn-->
            <!--                    icon-->
            <!--                    :small="appGuiCompact"-->
            <!--                    class="mx-1"-->
            <!--                    @click="extendedSearch=!extendedSearch;$nextTick(() => $refs.zoeken.focus())"-->
            <!--                    v-bind="attrs"-->
            <!--                    v-on="on"-->
            <!--                >-->
            <!--                  <v-icon-->
            <!--                      :color="extendedSearch ? 'accent' : 'grey lighten-1'"-->
            <!--                  >mdi-slash-forward</v-icon>-->
            <!--                </v-btn>-->
            <!--              </template>-->
            <!--              <span>Geavanceerd zoeken met scheidingsteken</span>-->
            <!--            </v-tooltip>-->

            <!--        EYE ICON - PREVIEW  -->

            <v-tooltip
                open-delay="1000"
                bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-badge
                    v-model="GET_TIPS"
                    content="Artikelen: Alle/Order"
                    overlap
                    offset-x="8em"
                    offset-y="1%"
                    color="accent darken-2"
                >
                  <!--  left  -->
                  <v-btn
                      icon
                      :small="appGuiCompact"
                      class="mx-1"
                      @click="previewMode=!previewMode;$nextTick(() => $refs.zoeken.focus())"
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon v-if="previewMode"
                            color="grey lighten-1"
                    >mdi-eye-off-outline
                    </v-icon>
                    <v-icon v-else
                            color="accent"
                    >mdi-eye-outline
                    </v-icon>
                  </v-btn>
                </v-badge>
              </template>
              <v-icon color="accent">mdi-eye-outline</v-icon>
              alle artikelen
              /
              <v-icon color="grey lighten-1">mdi-eye-off-outline</v-icon>
              order preview
            </v-tooltip>

            <!--
              8888888b.  8888888        d8888 888       .d88888b.   .d8888b.
              888  "Y88b   888         d88888 888      d88P" "Y88b d88P  Y88b
              888    888   888        d88P888 888      888     888 888    888
              888    888   888       d88P 888 888      888     888 888
              888    888   888      d88P  888 888      888     888 888  88888
              888    888   888     d88P   888 888      888     888 888    888
              888  .d88P   888    d8888888888 888      Y88b. .d88P Y88b  d88P
              8888888P"  8888888 d88P     888 88888888  "Y88888P"   "Y8888P88
            -->

            <!--    Artikel aantal aanpassen    -->
            <v-dialog
                id="dialog-edit-artikel"
                v-model="artikelDialog"
                max-width="600"
            >
              <v-card>
                <v-toolbar
                    color="accent"
                    dark
                    flat
                >
                  <v-toolbar-title
                      v-if="$vuetify.breakpoint.mdAndUp"
                  >Artikelcode
                  </v-toolbar-title>

                  <v-chip
                      class="d-inline-block mx-2"
                      color="primary"
                      @click="m_copy2Clipboard(editedItem.artikelcode)"
                      small
                  >{{ editedItem.artikelcode }}
                  </v-chip>

                  <v-badge
                      content="Artikelcode naar klembord"
                      :value="tips"
                      color="grey"
                      offset-y="4px"
                      overlap
                  >
                    <v-btn
                        icon
                        x-small
                        outlined
                        @click="m_copy2Clipboard(editedItem.artikelcode)"
                    >
                      <v-icon
                          x-small
                      >mdi-clipboard-arrow-right-outline
                      </v-icon>
                    </v-btn>
                  </v-badge>
                  <v-chip
                      v-if="showClipboardMessage"
                      :color="clipboardColor"
                      small
                      class="mx-4"
                  >{{ clipboardMessage }}
                  </v-chip>

                  <v-spacer></v-spacer>

                  <!--                  <v-toolbar-items>-->
                  <v-btn
                      icon
                      @click="artikelDialog = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <!--                  </v-toolbar-items>-->
                </v-toolbar>
                <v-card-title>
                  <span
                      class="text-truncate"
                      :class="{'caption': $vuetify.breakpoint.smAndDown}"
                  >
                    {{ editedItem.omschrijving }}
                  </span>
                </v-card-title>

                <v-card-text>
                  <v-container
                      class="mt-0"
                  >
                    <v-row>
                      <v-col
                          cols="12"
                          sm="12"
                          md="12"
                      >
                        <!--  @wheel.prevent="wheel = $event"-->
                        <!--  @focus="$event.target.select()"-->
                        <v-text-field
                            autofocus
                            v-model="editedItem.basket"
                            label="Aantal"
                            @keydown.enter="m_SaveArtikelDialog"
                            :suffix="editedItem.eenheid"
                            class="ma-1 dialog-big-input"
                            :color="getControlGUIColor()"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row
                        class="justify-space-around"
                    >
                      <v-btn
                          v-for="add in btnAantalToevoegen"
                          :key="add"
                          color="secondary"
                          class="ma-1"
                          :small="appGuiCompact"
                          @click="editedItem.basket=add; m_SaveArtikelDialog()"
                      >{{ add }}
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <!--  TIPS Icon: Ledje  -->
                  <v-icon
                      @mouseover="tips = true"
                      @mouseleave="tips = false"
                      :color="tips ? 'secondary' : ''"
                  >mdi-led-{{ tips ? 'on' : 'outline' }}
                  </v-icon>

                  <v-spacer></v-spacer>

                  <!--  ESCAPE-->
                  <v-badge
                      content="[ESC]"
                      :value="tips"
                      color="error"
                      left
                      bordered
                      overlap
                  >
                    <!--  CLOSE    -->
                    <!--                    <span>-->
                    <!--                      {{ $vuetify.breakpoint.width }}-->
                    <!--                    </span>-->
                    <v-btn
                        color="error"
                        class="mr-2"
                        text
                        outlined
                        :small="$vuetify.breakpoint.name === 'sm'"
                        @click="m_CloseArtikelDialog"
                    >
                      <span
                          v-if="$vuetify.breakpoint.name !== 'xs'"
                      >Annuleren</span>
                      <v-icon v-else>
                        mdi-cancel
                      </v-icon>
                    </v-btn>
                  </v-badge>

                  <!--  ENTER  -->
                  <v-badge
                      content="[Enter]"
                      :value="tips"
                      color="primary"
                      left
                      bordered
                      overlap
                  >
                    <v-btn
                        color="primary"
                        @click="m_SaveArtikelDialog"
                        :disabled="isNaN(editedItem.basket)"
                        :small="$vuetify.breakpoint.name === 'sm'"
                    >
                      <span
                          v-if="$vuetify.breakpoint.name !== 'xs'"
                      >Opslaan</span>
                      <v-icon v-else>
                        mdi-basket-outline
                      </v-icon>
                    </v-btn>
                  </v-badge>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!--
             .d8888b.           888    888    d8b
            d88P  Y88b          888    888    Y8P
            Y88b.               888    888
             "Y888b.    .d88b.  888888 888888 888 88888b.   .d88b.  .d8888b
                "Y88b. d8P  Y8b 888    888    888 888 "88b d88P"88b 88K
                  "888 88888888 888    888    888 888  888 888  888 "Y8888b.
            Y88b  d88P Y8b.     Y88b.  Y88b.  888 888  888 Y88b 888      X88
             "Y8888P"   "Y8888   "Y888  "Y888 888 888  888  "Y88888  88888P'
                                                                888
                                                           Y8b d88P
                                                            "Y88P"
            -->

            <!--  Bestelling formulier instellingen-->
            <v-dialog
                id="dialog-settings"
                v-model="settingsDialogModel"
                @keydown.esc="settingsDialogModel = false"
                max-width="1000"
                persistent
            >
              <v-card>
                <v-toolbar
                    :color="$vuetify.theme.dark ? '#909090' : '#D0D0D0'"
                >
                  <v-icon class="mr-2" large>mdi-cog</v-icon>

                  <v-toolbar-title>Instellingen</v-toolbar-title>

                  <v-spacer></v-spacer>

                  <!--                  <v-toolbar-items>-->
                  <v-btn
                      icon
                      @click="settingsDialogModel = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <!--                  </v-toolbar-items>-->

                  <!-- Tabs -->
                  <template v-slot:extension>
                    <v-tabs
                        v-model="settingsActiefTab"
                        align-with-title
                        show-arrows
                    >
                      <!--  active-class="gray"  -->
                      <v-tabs-slider color="secondary"></v-tabs-slider>
                      <v-tab
                          v-for="item in settingsTabItems"
                          :key="item"
                      >{{ item }}
                      </v-tab>
                    </v-tabs>
                  </template>
                </v-toolbar>

                <!--  Inhoud van tabs-->
                <v-tabs-items v-model="settingsActiefTab">
                  <v-tab-item>
                    <v-card
                        elevation="0"
                        :disabled="settingsBedrijfDialog.readOnly"
                    >
                      <!--    Bedrijf Tab Inhoud  -->

                      <!--
                       888888ba                 dP          oo oo .8888b      dP            dP
                       88    `8b                88                88   "      88            88
                      a88aaaa8P' .d8888b. .d888b88 88d888b. dP dP 88aaa     d8888P .d8888b. 88d888b.
                       88   `8b. 88ooood8 88'  `88 88'  `88 88 88 88          88   88'  `88 88'  `88
                       88    .88 88.  ... 88.  .88 88       88 88 88          88   88.  .88 88.  .88
                       88888888P `88888P' `88888P8 dP       dP 88 dP          dP   `88888P8 88Y8888'
                                                               88
                                                               dP
                      -->

                      <v-list
                          class="ma-4"
                          subheader
                      >
                        <v-subheader
                            v-if="settingsBedrijfDialog.readOnly"
                            class="error--text font-weight-bold mb-4"
                        >Instellingen van deze sectie is allen voor lezen, door restrictie van administratie eigenaar
                        </v-subheader>
                        <v-subheader
                            v-else
                            class="teal--text text-h6"
                        >Bedrijven filter
                        </v-subheader>
                        <!--    Bedrijf filter-->
                        <v-list-item>
                          <v-list-item-content>
                            <p>
                              Onderstaande bedrijven/filialen kan als order zender gebruiken.
                              Als er niks geselecteerd, mag alle bedrijven als order verzender gebruiken.
                            </p>
                            <v-autocomplete
                                label="Bedrijven"
                                v-model="settingsBedrijfDialog.selected"
                                :items="comp_KlantenCurAdm"
                                item-text="naam"
                                item-value="uuid"
                                :filter="bedrijfFilter"
                                hide-selected
                                chips
                                small-chips
                                clearable
                                deletable-chips
                                multiple
                                prepend-icon="mdi-city"
                                hint="Filteren kan met: relatiecode, naam, contactpersoon, postcode, straat, plaats en email"
                                persistent-hint
                            >
                              <template v-slot:selection="data">
                                <v-chip
                                    small
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    color="secondary"
                                    @click="data.select"
                                    @click:close="autocompleteRemove(data.item.uuid, settingsBedrijfDialog.selected)"
                                >
                                  {{ data.item.relatiecode }}: {{ data.item.naam }}
                                </v-chip>
                              </template>

                              <!--              Bedrijf DropDown lijst gegevens-->
                              <template v-slot:item="data">
                                <!--              Relatiecode -->
                                <v-list-item-action>
                                  <v-list-item-action-text>
                                    Code:
                                  </v-list-item-action-text>
                                  <v-list-item-action-text>
                                    <b>{{ data.item.relatiecode }}</b>
                                  </v-list-item-action-text>
                                </v-list-item-action>
                                <!--              Relatienaam  -->
                                <v-list-item-content>
                                  {{ data.item.naam }}
                                  <v-list-item-subtitle>
                                    <b>{{ data.item.vestigings_postcode }}</b>
                                    {{ data.item.vestigings_straat }}
                                    <b>{{ data.item.vestigings_plaats }}</b>
                                    <u class="ml-1">{{ data.item.email }}</u>
                                    <!--                                    <pre>{{ data.item }}</pre>-->
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </v-list-item-content>
                        </v-list-item>

                        <v-divider></v-divider>

                        <v-list-item-group
                            v-model="settingsBedrijfDialog.options"
                            multiple
                            active-class=""
                        >
                          <v-subheader
                              class="teal--text"
                          >Andere optie
                          </v-subheader>
                          <v-list-item>
                            <template v-slot:default="{ active }">
                              <v-list-item-action>
                                <v-checkbox
                                    :input-value="active"
                                ></v-checkbox>
                              </v-list-item-action>

                              <v-list-item-content>
                                <v-list-item-title>Verbergen bedrijf veld</v-list-item-title>
                                <v-list-item-subtitle
                                    :class="{'error--text': settingsBedrijfDialog.selected.length !== 1 && comp_KlantenCurAdm.length !== 1}"
                                >Deze optie werkt allen als één bedrijf geselecteerd
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-tab-item>

                  <!--
                  .d88888b  oo          dP       dP                                 dP            dP
                  88.    "'             88       88                                 88            88
                  `Y88888b. dP .d8888b. 88d888b. 88 .d8888b. .d8888b. 88d888b.    d8888P .d8888b. 88d888b.
                        `8b 88 88'  `88 88'  `88 88 88'  `88 88'  `88 88'  `88      88   88'  `88 88'  `88
                  d8'   .8P 88 88.  .88 88.  .88 88 88.  .88 88.  .88 88    88      88   88.  .88 88.  .88
                   Y88888P  88 `88888P8 88Y8888' dP `88888P' `88888P' dP    dP      dP   `88888P8 88Y8888'
                            88
                           .dP
                  -->

                  <v-tab-item>
                    <v-card
                        elevation="0"
                        :disabled="settingsSjabloonDialog.readOnly"
                    >
                      <v-list
                          class="ma-4"
                          subheader
                      >
                        <v-subheader
                            v-if="settingsSjabloonDialog.readOnly"
                            class="error--text font-weight-bold mb-4"
                        >Instellingen van deze sectie is allen voor lezen, door restrictie van administratie eigenaar
                        </v-subheader>
                        <v-subheader
                            v-else
                            class="teal--text text-h6"
                        >Verkooporder sjablonen filter
                        </v-subheader>
                        <v-list-item>
                          <v-list-item-content>
                            <p>
                              Onderstaande verkooporder sjablonen kunnen gebruiken.
                              Als er niks geselecteerd, mag alle sjablonen gebruiken.
                            </p>
                            <!--                                :filter="bedrijfFilter"-->
                            <v-autocomplete
                                v-model="settingsSjabloonDialog.selected"
                                :items="comp_FilteredSjablonen"
                                item-text="omschrijving"
                                item-value="uuid"
                                hide-selected
                                chips
                                small-chips
                                clearable
                                deletable-chips
                                multiple
                                label="Sjablonen"
                                prepend-icon="mdi-file-multiple-outline"
                                hint="Selecteer sjablonen die wil je gebruiken of selecteer niks om alles kunnen te gebruiken"
                                persistent-hint
                                class=""
                            >
                              <template v-slot:selection="data">
                                <v-chip
                                    small
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    color="secondary"
                                    @click="data.select"
                                    @click:close="autocompleteRemove(data.item.uuid, settingsSjabloonDialog.selected)"
                                >
                                  {{ data.item.omschrijving }}
                                </v-chip>
                              </template>

                              <!--              Sjabloon DropDown lijst gegevens-->
                              <template v-slot:item="data">
                                <v-list-item-content
                                    :class="{'font-weight-bold': data.item.id === prop_CurrentSjabloonID}"
                                >
                                  {{ data.item.omschrijving }}
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </v-list-item-content>
                        </v-list-item>

                        <v-divider></v-divider>

                        <v-list-item-group
                            v-model="settingsSjabloonDialog.options"
                            multiple
                            active-class=""
                        >
                          <v-subheader
                              class="teal--text"
                          >Andere optie
                          </v-subheader>
                          <!--                      Optie #0: hideWidget-->
                          <v-list-item>
                            <!--                        :disabled="settingsSjabloonDialog.selected.length !== 1 && comp_FilteredSjablonen.length !== 1"-->
                            <template v-slot:default="{ active }">
                              <v-list-item-action>
                                <v-checkbox
                                    :input-value="active"
                                ></v-checkbox>
                              </v-list-item-action>

                              <v-list-item-content>
                                <v-list-item-title>Verbergen sjabloon veld</v-list-item-title>
                                <v-list-item-subtitle
                                    :class="{'error--text': settingsSjabloonDialog.selected.length !== 1 && comp_FilteredSjablonen.length !== 1}"
                                >Deze optie werkt allen als één sjabloon geselecteerd
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </v-list-item>

                          <!--                      Optie #1: hideLeeg-->
                          <v-list-item>
                            <template v-slot:default="{ active }">
                              <v-list-item-action>
                                <v-checkbox
                                    :input-value="active"
                                ></v-checkbox>
                              </v-list-item-action>

                              <v-list-item-content>
                                <v-list-item-title>Verbergen sjabloon 'Leeg'</v-list-item-title>
                                <v-list-item-subtitle
                                >Deze optie werkt allen als aantal sjablonen meer dan één
                                  <!--                                    :class="{'error&#45;&#45;text': settingsSjabloonDialog.selected.length !== 1 && comp_FilteredSjablonen.length !== 1}"-->
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </v-list-item>

                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-tab-item>

                  <!--
                   .88888.                                 dP                                                                       dP            dP
                  d8'   `8b                                88                                                                       88            88
                  88     88 88d8b.d8b. d888888b .d8888b. d8888P .d8888b. 88d888b. .d8888b. .d8888b. 88d888b. .d8888b. 88d888b.    d8888P .d8888b. 88d888b.
                  88     88 88'`88'`88    .d8P' 88ooood8   88   88'  `88 88'  `88 88'  `88 88ooood8 88'  `88 88ooood8 88'  `88      88   88'  `88 88'  `88
                  Y8.   .8P 88  88  88  .Y8P    88.  ...   88   88.  .88 88       88.  .88 88.  ... 88.  .88 88.  ... 88    88      88   88.  .88 88.  .88
                   `8888P'  dP  dP  dP d888888P `88888P'   dP   `8888P88 dP       `88888P' `88888P' 88Y888P' `88888P' dP    dP      dP   `88888P8 88Y8888'
                                                                     .88                            88
                                                                 d8888P                             dP
                  -->

                  <!--Settings -> Omzetgroepen -->
                  <v-tab-item>
                    <v-card
                        elevation="0"
                        :disabled="settingsOmzetgroepenDialog.readOnly || comp_OmzetgroepenExAll.length <= 1"
                    >
                      <v-list
                          class="ma-4"
                          subheader
                      >
                        <v-subheader
                            v-if="settingsOmzetgroepenDialog.readOnly"
                            class="error--text font-weight-bold mb-4"
                        >Instellingen van deze sectie is allen voor lezen, door restrictie van administratie eigenaar
                        </v-subheader>
                        <v-subheader
                            v-if="comp_OmzetgroepenExAll.length <= 1"
                            class="error--text font-weight-bold mb-4"
                        >Instellingen van deze sectie is niet van toepassen met één omzetgroep
                        </v-subheader>
                        <v-subheader
                            v-else
                            class="teal--text text-h6"
                        >Omzetgroepen filter
                        </v-subheader>

                        <v-list-item>
                          <v-list-item-content>
                            <p>
                              Onderstaande omzetgroepen kunnen gebruiken.
                              Als er niks geselecteerd, mag alle omzetgroepen gebruiken.
                            </p>
                            <v-autocomplete
                                v-model="settingsOmzetgroepenDialog.selected"
                                :items="comp_OmzetgroepenExAll"
                                item-text="omschrijving"
                                item-value="uuid"
                                hide-selected
                                chips
                                small-chips
                                clearable
                                deletable-chips
                                multiple
                                label="Omzetgroepen"
                                prepend-icon="mdi-account-group-outline"
                                hint="Selecteer omzetgroepen die wil je gebruiken of selecteer niks om alles kunnen te gebruiken"
                                persistent-hint
                            >
                              <template v-slot:selection="data">
                                <v-chip
                                    small
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    color="secondary"
                                    @click="data.select"
                                    @click:close="autocompleteRemove(data.item.uuid, settingsOmzetgroepenDialog.selected)"
                                >
                                  {{ data.item.omschrijving }}
                                </v-chip>
                              </template>

                              <!--              Sjabloon DropDown lijst gegevens-->
                              <template v-slot:item="data">
                                <v-list-item-content
                                >
                                  <!--                              :class="{'font-weight-bold': data.item.id === prop_CurrentSjabloonID}"-->
                                  {{ data.item.omschrijving }}
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </v-list-item-content>
                        </v-list-item>

                        <v-divider></v-divider>

                        <v-list-item-group
                            v-model="settingsOmzetgroepenDialog.options"
                            multiple
                            active-class=""
                        >
                          <v-subheader
                              class="teal--text"
                          >Andere optie
                          </v-subheader>
                          <v-list-item>
                            <template v-slot:default="{ active }">
                              <v-list-item-action>
                                <v-checkbox
                                    :input-value="active"
                                ></v-checkbox>
                              </v-list-item-action>

                              <v-list-item-content>
                                <v-list-item-title>Verbergen omzetgroep veld</v-list-item-title>
                                <v-list-item-subtitle
                                    :class="{'error--text': settingsOmzetgroepenDialog.selected.length !== 1 && comp_Omzetgroepen.length !== 1}"
                                >Deze optie werkt allen als één omzetgroep geselecteerd
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </v-list-item>

                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-tab-item>

                  <!--
                  dP                            dP              dP                                       dP                                 dP            dP
                  88                            88              88                                       88                                 88            88
                  88        .d8888b. .d8888b. d8888P .d8888b. d8888P .d8888b.    .d8888b. 88d888b. .d888b88 .d8888b. 88d888b. .d8888b.    d8888P .d8888b. 88d888b.
                  88        88'  `88 88'  `88   88   Y8ooooo.   88   88ooood8    88'  `88 88'  `88 88'  `88 88ooood8 88'  `88 Y8ooooo.      88   88'  `88 88'  `88
                  88        88.  .88 88.  .88   88         88   88   88.  ...    88.  .88 88       88.  .88 88.  ... 88             88      88   88.  .88 88.  .88
                  88888888P `88888P8 `88888P8   dP   `88888P'   dP   `88888P'    `88888P' dP       `88888P8 `88888P' dP       `88888P'      dP   `88888P8 88Y8888'
                  -->

                  <v-tab-item>
                    <v-card
                        elevation="0"
                        :disabled="settingsLaatsteVerkooporders.readOnly"
                    >
                      <!--                      <v-card-text>Laatste orders</v-card-text>-->
                      <v-list
                          class="ma-4"
                          subheader
                      >
                        <v-subheader
                            v-if="settingsLaatsteVerkoopordersDialog.readOnly"
                            class="error--text font-weight-bold mb-4"
                        >Instellingen van deze sectie is allen voor lezen, door restrictie van administratie eigenaar
                        </v-subheader>
                        <v-subheader
                            v-else
                            class="teal--text text-h6"
                        >Laatste order filter
                          <span v-if="appDevMessages">&emsp;(settingsLaatsteVerkoopordersDialog)</span>
                        </v-subheader>
                        <v-list-item>
                          <v-list-item-content>
                            <p>Verkooporder process status</p>
                            <v-autocomplete
                                v-model="settingsLaatsteVerkoopordersDialog.selected"
                                :items="processStatusListEnabled"
                                item-text="text"
                                item-value="text"
                                hide-selected
                                chips
                                small-chips
                                clearable
                                deletable-chips
                                multiple
                                label="Process status"
                                prepend-icon="mdi-file-document-multiple-outline"
                                hint="Filter op verkooporder process statussen. Als er niks geselecteerd, filter staat uit."
                                persistent-hint
                            >
                              <!--      Process status select lijst   -->
                              <template v-slot:selection="data">
                                <v-chip
                                    small
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    color="secondary"
                                    @click="data.select"
                                    @click:close="autocompleteRemove(data.item.text, settingsLaatsteVerkoopordersDialog.selected)"
                                >
                                  <v-icon small class="mr-1">
                                    {{ data.item.icon }}
                                  </v-icon>
                                  {{ data.item.text }}
                                </v-chip>
                              </template>

                              <!--    Process status DropDown lijst item    -->
                              <template
                                  v-slot:item="data"
                              >
                                <v-list-item-action>
                                  <v-icon>
                                    {{ data.item.icon }}
                                  </v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                  {{ data.item.text }}
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>

                          </v-list-item-content>
                        </v-list-item>
                        <v-subheader>TODO: Laatste dagen/maanden</v-subheader>
                        <v-subheader>TODO: Laatste aantal</v-subheader>
                        <v-subheader>TODO: 'Blok' filter: Ja/Nee/Alles</v-subheader>
                        <v-list-item v-if="appDevMessages">
                          <v-list-item-content>
                            <pre>{{ settingsLaatsteVerkoopordersDialog }}</pre>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-tab-item>

                  <!--
                   888888ba                                                                      dP              dP                          dP            dP
                   88    `8b                                                                     88              88                          88            88
                  a88aaaa8P' 88d888b. .d8888b. .d8888b. .d8888b. .d8888b. .d8888b.    .d8888b. d8888P .d8888b. d8888P dP    dP .d8888b.    d8888P .d8888b. 88d888b.
                   88        88'  `88 88'  `88 88'  `"" 88ooood8 Y8ooooo. Y8ooooo.    Y8ooooo.   88   88'  `88   88   88    88 Y8ooooo.      88   88'  `88 88'  `88
                   88        88       88.  .88 88.  ... 88.  ...       88       88          88   88   88.  .88   88   88.  .88       88      88   88.  .88 88.  .88
                   dP        dP       `88888P' `88888P' `88888P' `88888P' `88888P'    `88888P'   dP   `88888P8   dP   `88888P' `88888P'      dP   `88888P8 88Y8888'
                  -->

                  <!--Setting -> Process status-->
                  <v-tab-item>
                    <v-card
                        elevation="0"
                        :disabled="settingsProcessStatusDialog.readOnly"
                    >
                      <v-list
                          class="ma-4"
                          subheader
                      >
                        <v-subheader
                            v-if="settingsProcessStatusDialog.readOnly"
                            class="error--text font-weight-bold mb-4"
                        >Instellingen van deze sectie is allen voor lezen, door restrictie van administratie eigenaar
                        </v-subheader>
                        <v-subheader
                            v-else
                            class="teal--text text-h6"
                        >Verkooporder process status
                        </v-subheader>
                        <v-list-item>
                          <v-list-item-content>
                            <p>
                              Onderstaande verkooporder process statussen kunnen gebruiken.
                              Als er niks geselecteerd, mag alle statussen gebruiken.
                            </p>
                            <v-autocomplete
                                v-model="settingsProcessStatusDialog.selected"
                                :items="processStatusList"
                                item-text="text"
                                item-value="text"
                                hide-selected
                                chips
                                small-chips
                                clearable
                                deletable-chips
                                multiple
                                label="Process status"
                                prepend-icon="mdi-file-document-multiple-outline"
                                hint="Selecteer process status die wil je gebruiken of selecteer niks om alles kunnen te gebruiken"
                                persistent-hint
                            >
                              <!--      Process status select lijst -->
                              <template v-slot:selection="data">
                                <v-chip
                                    small
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    color="secondary"
                                    @click="data.select"
                                    @click:close="autocompleteRemove(data.item.text, settingsProcessStatusDialog.selected)"
                                >
                                  <v-icon small class="mr-1">
                                    {{ data.item.icon }}
                                  </v-icon>
                                  {{ data.item.text }}
                                </v-chip>
                              </template>

                              <!--      Process status DropDown lijst item-->
                              <template v-slot:item="data"
                              >
                                <v-list-item-action>
                                  <v-icon :disabled="data.item.disabled">{{ data.item.icon }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content
                                    :class="{'font-weight-bold': data.item.text === prop_ProcessStatusName}"
                                >
                                  {{ data.item.text }}
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </v-list-item-content>
                        </v-list-item>

                        <v-divider></v-divider>

                        <v-list-item-group
                            v-model="settingsProcessStatusDialog.options"
                            multiple
                            active-class=""
                        >
                          <v-subheader
                              class="teal--text"
                          >Andere optie
                          </v-subheader>
                          <!--                      Optie #0-->
                          <v-list-item>
                            <!--                        :disabled="settingsSjabloonDialog.selected.length !== 1 && comp_FilteredSjablonen.length !== 1"-->
                            <template v-slot:default="{ active }">
                              <v-list-item-action>
                                <v-checkbox
                                    :input-value="active"
                                ></v-checkbox>
                              </v-list-item-action>

                              <v-list-item-content>
                                <v-list-item-title>Verbergen process status</v-list-item-title>
                                <v-list-item-subtitle
                                    :class="{'error--text': settingsProcessStatusDialog.selected.length !== 1}"
                                >Deze optie werkt allen als één process status geselecteerd
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                          <!--                      Optie #1-->
                          <v-list-item>
                            <!--                        :disabled="settingsSjabloonDialog.selected.length !== 1 && comp_FilteredSjablonen.length !== 1"-->
                            <template v-slot:default="{ active }">
                              <v-list-item-action>
                                <v-checkbox
                                    :input-value="active"
                                ></v-checkbox>
                              </v-list-item-action>

                              <v-list-item-content>
                                <v-list-item-title>Verbergen omschrijving</v-list-item-title>
                                <v-list-item-subtitle
                                >Omschrijving komt allen, als applicatie venster groter dan 800 pixels
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </v-list-item>

                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-tab-item>

                  <!--      Zending info  -->
                  <v-tab-item>
                    <v-card>
                      <v-card-text>Zending info</v-card-text>
                    </v-card>
                  </v-tab-item>

                  <!--      Artikelen  -->
                  <v-tab-item>
                    <v-card
                        elevation="0"
                        :disabled="settingsArtikelenDialog.readOnly"
                    >
                      <v-btn
                          @click="settingsArtikelenDialog.fieldFilters.push(['omschrijving', '=', ''])"
                          fab
                          absolute
                          top
                          right
                          color="accent"
                          class="mt-6 mr-4"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                      <v-list
                          class="ma-4"
                          subheader
                      >
                        <v-subheader
                            v-if="settingsArtikelenDialog.readOnly"
                            class="error--text font-weight-bold mb-4"
                        >Instellingen van deze sectie is allen voor lezen, door restrictie van administratie eigenaar
                        </v-subheader>
                        <v-subheader
                            v-else
                            class="teal--text text-h6"
                        >Artikelen filteren
                          <span v-if="appDevMessages">&emsp;(settingsArtikelenDialog)</span>
                        </v-subheader>
                        <!--    Filteren    -->
                        <v-subheader v-if="settingsArtikelenDialog.fieldFilters">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  class="pr-2"
                              >mdi-information-outline
                              </v-icon>
                            </template>
                            <span>
                              Filter operators:
                              <ul style="list-style-type:none">
                                <li><b>=</b> - is gelijk</li>
                                <li><b>?=</b> - gelijk or leeg</li>
                                <li><b>!=</b> - niet gelijk</li>
                                <li><b>&gt;</b> - groter</li>
                                <li><b>&lt;</b> - minder</li>
                                <li><b>&gt;&equals;</b> - groter of gelijk</li>
                                <li><b>&lt;&equals;</b> - minder is gelijk</li>
                                <li><b>in</b> - in de lijst (comma separated)</li>
                                <li><b>?in</b> - leeg of in de lijst (comma separated)</li>
                                <li><b>not in</b> - niet in de lijst (comma separated)</li>
                                <li><b>true</b> - is waar</li>
                                <li><b>false</b> - is onwaar</li>
                                <li><b>starts with</b> - string begint met</li>
                                <li><b>ends with</b> - string eindigen met</li>
                                <li><b>contains</b> - string bevat</li>
                              </ul>
                            </span>
                          </v-tooltip>
                          Filters:
                        </v-subheader>
                        <v-list-item v-if="settingsArtikelenDialog.fieldFilters">
                          <v-list-item-content>
                            <!--    <pre>settingsArtikelenDialog: {{ settingsArtikelenDialog }}</pre>   -->
                            <v-row
                                v-for="(filter, index) in settingsArtikelenDialog.fieldFilters"
                                :key="index"
                            >
                              <!--    Filter: Veldnaam    -->
                              <v-col
                                  v-if="filter.length === 3"
                                  cols="5"
                              >
                                <v-select
                                    v-model="filter[0]"
                                    :items="comp_ArtikelenFieldsList"
                                    label="Veldnaam"
                                >
                                  <template v-slot:prepend>
                                    <v-icon
                                        @click="settingsArtikelenDialog.fieldFilters.splice(index, 1)"
                                        color="error"
                                    >mdi-close
                                    </v-icon>
                                  </template>
                                </v-select>
                              </v-col>

                              <!--Filter: Operator-->
                              <v-col
                                  v-if="filter.length === 3"
                                  cols="2"
                              >
                                <v-select
                                    v-model="filter[1]"
                                    :items="comp_ArtikelenDialogFiltersList"
                                    label="Operator"
                                >
                                </v-select>
                              </v-col>

                              <!--Filter: value-->
                              <v-col
                                  v-if="filter.length === 3"
                                  cols="5"
                              >
                                <v-text-field
                                    v-model="filter[2]"
                                    label="Gegevens"
                                    clearable
                                ></v-text-field>
                              </v-col>
                              <p
                                  v-else
                                  style="color: firebrick"
                              >Invalid formaat:{{ filter }}</p>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                          <v-list-item-content>
                            <v-row>
                              <v-col class="px-6 mt-6">
                                <v-slider
                                    v-model="settingsArtikelenDialogIndex"
                                    min="0"
                                    :max="comp_ArtikelenFromCurAdm.length - 1"
                                    :disabled="comp_ArtikelenFromCurAdm.length < 1"
                                    thumb-size="32"
                                    thumb-label
                                >
                                </v-slider>
                                <v-text-field
                                    v-model="settingsArtikelenDialogIndex"
                                    :rules="[settingsArtikelenDialogRules.indexLimit, settingsArtikelenDialogRules.positief]"
                                    class="mt-0 pt-0"
                                    hide-details
                                    single-line
                                    type="number"
                                    style="width: 20em"
                                    outlined
                                >
                                  <template v-slot:prepend>comp_ArtikelenFromCurAdm[</template>
                                  <template v-slot:append-outer>]:</template>
                                </v-text-field>
                                <pre>{{ comp_ArtikelenFromCurAdm[settingsArtikelenDialogIndex] }}</pre>
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>

                <v-divider></v-divider>

                <!--  Dialog action-->
                <v-card-actions>

                  <v-spacer></v-spacer>

                  <v-btn
                      color="primary"
                      @click="m_saveSettingsDialog"
                  >
                    Opslaan
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <!--
        88888888888          888               888                                          888
            888              888               888                                          888
            888              888               888                                          888
            888      8888b.  88888b.   .d88b.  888       888d888  .d88b.   .d88b.   .d88b.  888 .d8888b
            888         "88b 888 "88b d8P  Y8b 888       888P"   d8P  Y8b d88P"88b d8P  Y8b 888 88K
            888     .d888888 888  888 88888888 888       888     88888888 888  888 88888888 888 "Y8888b.
            888     888  888 888 d88P Y8b.     888       888     Y8b.     Y88b 888 Y8b.     888      X88
            888     "Y888888 88888P"   "Y8888  888       888      "Y8888   "Y88888  "Y8888  888  88888P'
                                                                               888
                                                                          Y8b d88P
                                                                           "Y88P"
        -->

        <!--    Voorraad indicator-->
        <template
            v-if="settingsVoorraadIndicator.show"
            v-slot:[`item.vrije_voorraad`]="{ item }"
        >
          <template
              v-if="settingsVoorraadIndicator.widget === 'digit'"
          >
            <v-chip
                v-if="item.vrije_voorraad > settingsVoorraadIndicator.default_green_level"
                label
                outlined
            >
              {{ settingsVoorraadIndicator.default_green_level + '+' }}
            </v-chip>
            <v-chip
                v-else-if="item.vrije_voorraad > settingsVoorraadIndicator.default_red_level"
                label
                outlined
            >
              {{ item.vrije_voorraad }}
            </v-chip>
            <!--            <v-chip-->
            <!--              v-else-->
            <!--              label-->
            <!--              outlined-->
            <!--            >-->
            <!--              {{ item.vrije_voorraad }}-->
            <!--            </v-chip>-->
          </template>
          <template
              v-else
          >
            <v-tooltip
                left
                v-if="item.voorraad_controle"
                :disabled="!settingsVoorraadIndicator.tooltip || item.vrije_voorraad <= 0"
            >
              <template v-slot:activator="{ on, attrs }">
                <!--              <span>{{ item.vrije_voorraad }}</span>-->
                <v-btn
                    icon
                    :small="appGuiCompact"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon
                      :small="appGuiCompact"
                      :color="m_getVoorraadColor(item)"
                  >mdi-circle
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ item.vrije_voorraad }}</span>
            </v-tooltip>

          </template>

          <!--          <v-badge-->
          <!--              v-if="item.voorraad_controle"-->
          <!--              :dot="appGuiCompact"-->
          <!--              :color="m_getVoorraadColor(item)"-->
          <!--              inline-->
          <!--          >-->
          <!--            {{ item.vrije_voorraad }}-->
          <!--          </v-badge>-->
        </template>

        <!--    Artikelcode    -->
        <template v-slot:[`item.artikelcode`]="{ item }">
          <v-tooltip
              top
              open-delay="300"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  :x-small="appGuiCompact"
                  :small="!appGuiCompact"
                  v-model="item.artikelcode"
                  text-color="black"
                  v-bind="attrs"
                  v-on="on"
                  :color="m_getColorFromOmzetgroepID(item.omzetgroep.id)"
              >{{ item.artikelcode }}
              </v-chip>
            </template>
            <span>{{ item.omzetgroep.omschrijving }}</span>
          </v-tooltip>
        </template>

        <!--    Omschrijving: Bold -> in basket   -->
        <template v-slot:[`item.omschrijving`]="{ item }">
          <!--              :class="[item.basket ? 'font-weight-bold' : '']"-->
          <!--              style="font-size: 90%"-->
          <span
              :style="{fontSize: appGuiCompact ? 'smaller' : ''}"
              :class="{'font-weight-bold' : item.basket}"
          >{{ item.omschrijving }}</span>
        </template>

        <!--    Inkoopprijs   -->
        <template v-slot:[`item.inkoopprijs`]="{ item }">
          <span :class="{'red--text': item.inkoopprijs < 0}">
            {{ item.inkoopprijs | getEuro }}
          </span>
        </template>

        <!--    Verkoopprijs   -->
        <template v-slot:[`item.verkoopprijs`]="{ item }">
          <span :class="{'red--text': item.verkoopprijs < 0}">
            {{ item.verkoopprijs | getEuro }}
          </span>
        </template>

        <!--    TODO: Hardcoded! Moet anders  -->
        <!--    Retailprice   -->
        <template v-slot:[`item.extra_velden_Retailprice`]="{ item }">
          <span :class="{'red--text': item.extra_velden_Retailprice < 0}">
            {{ item.extra_velden_Retailprice | getEuro }}
          </span>
        </template>

        <!--    Aantal    -->
        <template v-slot:[`item.basket`]="{ item }">
          <div class="d-flex justify-space-between align-center">
            <!--MINUS-->
            <v-btn
                :color="item.basket === 0 ? 'gray' : 'primary'"
                :depressed="item.basket === 0"
                :x-small="appGuiCompact"
                :small="!appGuiCompact"
                @click.stop="m_MinOneArtikel(item)"
                class="mx-2"
                :disabled="ss_GetArtikelenProgress.loading"
            >
              <v-icon
              >mdi-minus
              </v-icon>
            </v-btn>

            <!--AANTAL-->
            <span
                style="font-size: larger"
                :class="isNaN(item.basket) ? 'error--text' : ''"
            >
              <span
                  class="font-weight-bold"
              >{{ item.basket }}</span>

              <span
                  v-if="item.eenheid"
                  class="ml-2"
                  style="font-size: small"
              >{{ (Number(item.eenheid) !== item.eenheid) ? item.eenheid : `(${item.eenheid})` }}</span>

            </span>
            <!--PLUS-->
            <v-btn
                color="secondary"
                :x-small="appGuiCompact"
                :small="!appGuiCompact"
                @click.stop="m_PlusOneArtikel(item)"
                class="mx-2"
                :disabled="ss_GetArtikelenProgress.loading"
            >
              <v-icon
              >mdi-plus
              </v-icon>
            </v-btn>
          </div>
        </template>

        <!--    ITEM ACTIONS: +, Clear    -->
        <template v-slot:[`item.actions`]="{ item }">

          <!--  BASKET PLUS   -->
          <v-icon
              class="mr-2"
              color="accent"
              @click.stop="m_EditArtikelItem(item)"
              :disabled="ss_GetArtikelenProgress.loading"
              :large="!appGuiCompact"
          >mdi-basket-fill
          </v-icon>

          <!--  BASKET CLEAR  -->
          <v-icon
              v-if="item.basket"
              color="error"
              @click.stop="m_ClearArtikelItem(item)"
              :large="!appGuiCompact"
          >mdi-close-thick
          </v-icon>
        </template>

      </v-data-table>

      <!--
      888                   888             888                    .d88888b.               888
      888                   888             888                   d88P" "Y88b              888
      888                   888             888                   888     888              888
      888  8888b.   8888b.  888888 .d8888b  888888  .d88b.        888     888 888d888  .d88888  .d88b.  888d888
      888     "88b     "88b 888    88K      888    d8P  Y8b       888     888 888P"   d88" 888 d8P  Y8b 888P"
      888 .d888888 .d888888 888    "Y8888b. 888    88888888       888     888 888     888  888 88888888 888
      888 888  888 888  888 Y88b.       X88 Y88b.  Y8b.           Y88b. .d88P 888     Y88b 888 Y8b.     888
      888 "Y888888 "Y888888  "Y888  88888P'  "Y888  "Y8888         "Y88888P"  888      "Y88888  "Y8888  888

      8888888b.  d8b          888
      888  "Y88b Y8P          888
      888    888              888
      888    888 888  8888b.  888  .d88b.   .d88b.
      888    888 888     "88b 888 d88""88b d88P"88b
      888    888 888 .d888888 888 888  888 888  888
      888  .d88P 888 888  888 888 Y88..88P Y88b 888
      8888888P"  888 "Y888888 888  "Y88P"   "Y88888
                                                888
                                           Y8b d88P
                                            "Y88P"
      -->

      <v-dialog
          id="dialog-laatste-order"
          v-model="laatsteOrderDialog"
          max-width="50em"
      >
        <v-card>
          <!--Toolbar-->
          <v-toolbar
              id="form-header"
              color="info"
              flat
              dark
              :dense="appGuiCompact"
          >
            <!--            Titel-->
            <v-toolbar-title>
              <v-icon large>mdi-file-plus-outline</v-icon>
              Voeg laatste order(s) toe...
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <!--            <v-toolbar-items>-->
            <!--              <v-btn><v-icon>mdi-refresh</v-icon>Test</v-btn>-->
            <!--    Verkooporders REFRESH-->
            <v-tooltip
                open-delay="1000"
                bottom
            >
              <template v-slot:activator="{ on, attrs}">
                <v-badge
                    v-model="tips"
                    overlap
                    left
                    content="Refresh orders"
                    offset-y="16"
                >
                  <v-btn
                      @click="m_loadVerkoopOrders"
                      :loading="ss_GetVerkoopOrdersProgress.loading"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                  >
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </v-badge>
              </template>
              Verkooporders opnieuw lezen
            </v-tooltip>

            <v-badge
                v-model="tips"
                overlap
                left
                content="[ESC]"
                color="grey"
                class="ml-8"
            >
              <v-btn
                  icon
                  @click="laatsteOrderDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-badge>
          </v-toolbar>

          <v-card-text>
            <v-container>
              <v-row>
                <!--
                 .88888.                 dP                      d888888P          dP       dP
                d8'   `8b                88                         88             88       88
                88     88 88d888b. .d888b88 .d8888b. 88d888b.       88    .d8888b. 88d888b. 88 .d8888b.
                88     88 88'  `88 88'  `88 88ooood8 88'  `88       88    88'  `88 88'  `88 88 88ooood8
                Y8.   .8P 88       88.  .88 88.  ... 88             88    88.  .88 88.  .88 88 88.  ...
                 `8888P'  dP       `88888P8 `88888P' dP             dP    `88888P8 88Y8888' dP `88888P'
                -->
                <v-data-table
                    id="laatste-orders"
                    :dense="appGuiCompact"
                    :headers="laatsteOrderHeader"
                    :items="comp_VerkoopOrdersInLastOrdersDialogFiltered"
                    :search="laatsteOrderZoeken"
                    height="50hv"
                    item-key="id"
                    locale="NL-nl"
                    class="elevation-0"
                    show-expand
                    single-expand
                    :footer-props="{
                      'items-per-page-text': 'Orders per pagina:',
                      'items-per-page-options': [5, 10, 25, 100],
                      // 'disable-items-per-page': true,
                    }"
                >
                  <!--
                   .88888.                 dP
                  d8'   `8b                88
                  88     88 88d888b. .d888b88 .d8888b. 88d888b.
                  88     88 88'  `88 88'  `88 88ooood8 88'  `88
                  Y8.   .8P 88       88.  .88 88.  ... 88
                   `8888P'  dP       `88888P8 `88888P' dP

                  d888888P                   dP dP
                     88                      88 88
                     88    .d8888b. .d8888b. 88 88d888b. .d8888b. 88d888b.
                     88    88'  `88 88'  `88 88 88'  `88 88'  `88 88'  `88
                     88    88.  .88 88.  .88 88 88.  .88 88.  .88 88
                     dP    `88888P' `88888P' dP 88Y8888' `88888P8 dP
                  -->
                  <template v-slot:top>
                    <v-toolbar flat>

                      <!--      MENU: ORDER PROCESS STATUS    -->
                      <v-menu
                          id="laatste-order-process-status"
                          rounded="b-xl"
                          offset-y
                      >
                        <template v-slot:activator="{ on: menu, attrs }">
                          <v-tooltip
                              open-delay="1000"
                              bottom
                          >
                            <template v-slot:activator="{ on: tooltip }">
                              <v-badge
                                  v-model="tips"
                                  overlap
                                  left
                                  content="status"
                                  color="primary darken-1"
                              >
                                <v-btn
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="{ ...tooltip, ...menu }"
                                    :small="appGuiCompact"
                                >
                                  <v-icon
                                      class="mx-1"
                                      :small="appGuiCompact"
                                  >{{ processStatusListFilter[laatsteOrderDialogFilters.processStatusLijstModel].icon }}
                                  </v-icon>
                                </v-btn>
                              </v-badge>
                            </template>
                            <!--      Tooltip text-->
                            <span
                            >Process status: {{
                                processStatusListFilter[laatsteOrderDialogFilters.processStatusLijstModel].text
                              }}
                            </span>
                          </v-tooltip>
                        </template>

                        <v-list :dense="appGuiCompact">
                          <v-list-item-group
                              v-model="laatsteOrderDialogFilters.processStatusLijstModel"
                          >
                            <!--                v-for="item in comp_ProcessStatusListExcludeEmpty"-->
                            <v-list-item
                                v-for="item in processStatusListFilter"
                                :key="item.id"
                                link
                                :dense="appGuiCompact"
                                max-heigth="15"
                                :class="{'d-none': getOrderCountPerStatusID(item.id) === 0}"
                            >
                              <v-icon
                                  class="mr-2"
                                  small
                              >
                                <!--                                  :disabled="processStatusListFilter[laatsteOrderDialogFilters.processStatusLijstModel].id !== item.id"-->
                                {{ item.icon }}
                              </v-icon>

                              <v-list-item-title
                                  v-text="item.text"
                                  class="my-0"
                                  :class="{'font-weight-bold': laatsteOrderDialogFilters.processStatusLijstModel === item.id}"
                              ></v-list-item-title>
                              <!--                                  :class="{'font-weight-bold': processStatusListFilter[laatsteOrderDialogFilters.processStatusLijstModel].id === item.id}"-->
                              <v-chip
                                  x-small
                                  class="ml-2"
                                  color="accent"
                              >{{ getOrderCountPerStatusID(item.id) }}
                              </v-chip>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-menu>

                      <!--      MENU: ORDER GEBLOKKEERD -->

                      <v-menu
                          v-if="m_VerkoopOrdersInLastOrdersDialog_BlockCount(true) > 0"
                          id="order-geblokkeerd"
                          rounded="b-xl"
                          offset-y
                      >
                        <template
                            v-slot:activator="{ on: menu, attrs }"
                        >
                          <v-tooltip
                              open-delay="1000"
                              bottom
                          >
                            <template
                                v-slot:activator="{ on: tooltip }"
                            >
                              <!--    value="Order"-->
                              <!--    color="gray"-->
                              <v-badge
                                  v-model="tips"
                                  overlap
                                  left
                                  content="blok"
                                  color="secondary darken-1"
                                  class="ml-8"
                              >
                                <v-btn
                                    color="secondary"
                                    v-bind="attrs"
                                    v-on="{ ...tooltip, ...menu }"
                                    :small="appGuiCompact"
                                >
                                  <v-icon
                                      class="mx-1"
                                      :small="appGuiCompact"
                                  >{{ geblokkeerdListFilter[laatsteOrderDialogFilters.geblokkeerdListModel].icon }}
                                  </v-icon>
                                </v-btn>
                              </v-badge>
                            </template>
                            <!--      Tooltip text-->
                            <span>Blokkade:
                              {{ geblokkeerdListFilter[laatsteOrderDialogFilters.geblokkeerdListModel].text }}
                            </span>
                          </v-tooltip>
                        </template>

                        <v-list :dense="appGuiCompact">
                          <v-list-item-group
                              v-model="laatsteOrderDialogFilters.geblokkeerdListModel"
                          >
                            <v-list-item
                                v-for="item in geblokkeerdListFilter"
                                :key="item.id"
                                link
                                :dense="appGuiCompact"
                                max-heigth="15"
                                active-class=""
                            >
                              <v-icon
                                  class="mr-2"
                                  small
                                  :disabled="geblokkeerdListFilter[laatsteOrderDialogFilters.geblokkeerdListModel].id !== item.id"
                              >
                                {{ item.icon }}
                              </v-icon>
                              <v-list-item-title
                                  v-text="item.text"
                                  class="my-0"
                                  :class="{'font-weight-bold': geblokkeerdListFilter[laatsteOrderDialogFilters.geblokkeerdListModel].id === item.id}"
                              ></v-list-item-title>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-menu>

                      <!--  BEDRIJF / CONTACT   -->
                      <v-autocomplete
                          v-if="comp_RelatiesInLastOrdersDialog.length > 1"
                          v-model="selectedRelatieIDInLastOrdersDialog"
                          :items="comp_RelatiesInLastOrdersDialog"
                          @change="laatsteOrderDialogFilters.processStatusLijstModel = 0"
                          :dense="appGuiCompact"
                          label="Bedrijf / contact"
                          item-text="naam"
                          item-value="id"
                          single-line
                          class="mx-4 mb-n6"
                          clearable
                          style="max-width:16em"
                      >
                        <!--                          id="id"-->
                        <template
                            v-slot:item="{ item }"
                        >
                          <v-chip class="mr-2" small>{{ item.relatiecode }}</v-chip>
                          {{ item.naam }}
                        </template>
                      </v-autocomplete>

                      <v-spacer></v-spacer>

                      <!--      ZOEKEN VELD   -->
                      <v-text-field
                          id="laastOrderZoeken"
                          v-model="laatsteOrderZoeken"
                          prepend-inner-icon="mdi-magnify"
                          label="Zoeken"
                          single-line
                          hide-details
                          autofocus
                          clearable
                          class="shrink"
                          style="max-width:12em"
                          :background-color="comp_GetSearchColor"
                          :color="getControlGUIColor()"
                      ></v-text-field>
                    </v-toolbar>
                  </template>

                  <!--  (˅) Expand sectie  -->
                  <template v-slot:expanded-item="{ headers, item }"
                            class="elevation-0">
                    <!--                Order header    -->
                    <td :colspan="headers.length" class="px-0">
                      <v-subheader
                          class="text-center info rounded-t-lg"
                          v-if="!!item.memo"
                      >{{ item.memo }}
                      </v-subheader>
                      <!--                  Order regels    -->
                      <v-simple-table
                          :dense="appGuiCompact"
                          class="grey rounded-lg"
                          :class="[$vuetify.theme.dark ? 'darken-3' : 'lighten-4', {'rounded-t-0': !!item.memo}]"
                      >
                        <template v-slot:default>

                          <!--                      Sub table header -->
                          <thead>
                          <tr>
                            <th>#</th>
                            <th class="text-left">
                              Omschrijving
                            </th>
                            <th class="text-left">
                              Aantal
                            </th>
                            <th class="text-left">
                              Verkoopprijs
                            </th>
                          </tr>
                          </thead>
                          <!--      Sub table data -->
                          <tbody>
                          <tr
                              v-for="reg in [...item.regels].sort((a, b) => a.id - b.id)"
                              :key="reg.id"
                          >
                            <td>
                              <v-chip
                                  v-if="reg.artikel"
                                  x-small
                                  color="secondary"
                              >
                                {{ reg.artikel.artikelcode }}
                              </v-chip>
                            </td>
                            <!--  Omschrijving    -->
                            <!--  class -> Artikel staat niet in de artikelen list -> Grijs   -->
                            <td
                                v-if="comp_ArtikelenFromCurAdmWithFilter.some(i => reg.artikel === null || i.uuid === reg.artikel.uuid)"
                                style="font-size: 75%"
                            >
                                <span
                                    v-if="reg.omschrijving"
                                >
                                  {{ reg.omschrijving }}
                                </span>
                              <span
                                  v-else
                                  class="text--disabled"
                              >

                                  <!-- ℹ - icon met tooltip: (Leeg)   -->
                                  <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                          icon
                                          v-bind="attrs"
                                          v-on="on"
                                          x-small
                                      >
                                        <v-icon
                                            color="grey lighten-1"
                                            small
                                        >mdi-dots-horizontal</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Leeg regel</span>
                                  </v-tooltip>
                                </span>
                            </td>
                            <td
                                v-else
                                class="text--disabled"
                                style="font-size: 65%"
                            >
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      icon
                                      x-small
                                      :loading="ss_GetArtikelenProgress.loading"
                                  >
                                    <v-icon
                                        small
                                        color="error"
                                    >mdi-alert-octagon-outline
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Artikel is verwijderd of verborgen</span>
                              </v-tooltip>
                              {{ reg.omschrijving }}
                            </td>

                            <!--                    Aantal  -->
                            <td
                                style="font-size: small"
                            >{{ (reg.aantal) ? reg.aantal : '' }}
                            </td>

                            <!--                    Prijs   -->
                            <td
                                style="font-size: small"
                                :class="{'red--text': reg.totaal < 0}"
                            >
                              <span
                                  class="font-weight-black"
                              >
                                  {{ reg.totaal | getEuro }}
                              </span>
                              <span
                                  v-if="reg.kortings_percentage > 0"
                              >
                                ({{ reg.kortings_percentage }}% korting)
                              </span>
                              <span
                                  class="error--text"
                                  v-if="reg.kortings_percentage < 0"
                              >
                                ({{ -reg.kortings_percentage }}% verhoging)
                              </span>
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </td>
                  </template>

                  <!--    Order Status Icon -->
                  <template v-slot:[`item.order_status`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            :small="appGuiCompact"
                        >{{ m_getProcessStatusFromID(item.order_status).icon }}
                        </v-icon>
                      </template>
                      <span>{{ m_getProcessStatusFromID(item.order_status).text }}</span>
                    </v-tooltip>
                  </template>

                  <!--    Order # Item -->
                  <template v-slot:[`item.nummer`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                            v-bind="attrs"
                            v-on="on"
                        >
                          <v-chip x-small>
                            {{ item.nummer }}
                          </v-chip>
                        </span>
                      </template>
                      {{ getRelatieFromID(item.relatie_id).naam }}
                    </v-tooltip>
                  </template>

                  <!--    Datum Item -->
                  <template v-slot:[`item.datum`]="{ item }">
                    {{ item.datum | moment('DD-MM-YYYY') }}
                  </template>

                  <!--    Totaal Item -->
                  <template v-slot:[`item.totaal_exclusief_btw`]="{ item }">
                    <span :class="{'red--text': item.totaal_exclusief_btw < 0}">
                      {{ item.totaal_exclusief_btw | getEuro }}
                    </span>
                    <span
                        v-if="item.factuurkorting > 0"
                    >
                      ({{ item.factuurkorting }}% korting)
                    </span>
                    <span
                        class="error--text"
                        v-if="item.factuurkorting < 0"
                    >
                      ({{ item.factuurkorting }}% verhoging)
                    </span>
                  </template>

                  <!--    Action: Order in Basket -->
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                        @click="m_VoegLaatsteOrderInBasket(item)"
                        :x-small="appGuiCompact"
                        :small="!appGuiCompact"
                        color="secondary"
                        :disabled="ss_GetGlobalProgressFlag || laatsteOrderInProgress"
                    >
                      <v-icon
                          :small="appGuiCompact"
                      >mdi-basket-plus-outline
                      </v-icon>
                    </v-btn>
                  </template>

                  <!--    LED HELPER-->
                  <template v-slot:[`footer.prepend`]>
                    <v-icon
                        @mouseover="tips = true"
                        @mouseleave="tips = false"
                        class="mt-4"
                        :color="tips ? 'secondary' : ''"
                    >mdi-led-{{ tips ? 'on' : 'outline' }}
                    </v-icon>
                  </template>

                </v-data-table>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!--
      888888ba   88888888b  888888ba  dP     dP  .88888.
      88    `8b  88         88    `8b 88     88 d8'   `88
      88     88  a88aaaa    a88aaaa8P'88     88 88
      88     88  88         88    `8b.88     88 88   YP88
      88    .8P  88         88    .88 Y8.   .8P Y8.   .88
      8888888P   88888888P  88888888P `Y88888P'  `88888'
      -->

      <div
          id="debug-info"
          v-if="appDevMessages"
      >
        <v-row class="ma-1">
          <v-col cols="6">
            <v-card>
              <v-card-title>Selected operator</v-card-title>
              <v-card-subtitle>user_GetCurrentOperator</v-card-subtitle>
              <v-card-text>
                <pre>{{ user_GetCurrentOperator }}</pre>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card>
              <v-card-title>Klant configuratie</v-card-title>
              <v-card-subtitle>comp_CurrentKlantConfig</v-card-subtitle>
              <v-card-text>
                <pre>{{ comp_CurrentKlantConfig }}</pre>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card>
              <v-card-title>Klant profiel</v-card-title>
              <v-card-subtitle>user_GetCurrentProfiel.userprofile</v-card-subtitle>
              <v-card-text>
                <pre>{{ user_GetCurrentProfiel.userprofile }}</pre>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card>
              <v-card-title>Eerste Verkooporder</v-card-title>
              <v-card-subtitle>comp_VerkoopOrdersFromCurAdm[0]</v-card-subtitle>
              <v-card-text>
                <pre
                    v-if="comp_VerkoopOrdersFromCurAdm && comp_VerkoopOrdersFromCurAdm.length > 0"
                >{{ comp_VerkoopOrdersFromCurAdm[0] }}
                </pre>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="2">
            <v-card>
              <v-card-title>Sjablonen</v-card-title>
              <v-card-text v-for="item in comp_FilteredSjablonen" :key="item.id">
                ID:
                <span
                    :class="item.id === prop_CurrentSjabloonID ? 'font-weight-bold': ''"
                >{{ item.id }}
                </span>
                ,
                <span
                    :class="item.id === prop_CurrentSjabloonID ? 'text-decoration-underline': ''"
                >
                {{ item.omschrijving }}
                </span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card>
              <v-card-title>Omzetgroepen</v-card-title>
              <v-card-text v-for="item in comp_Omzetgroepen" :key="item.id">
                <span>{{ item }}</span>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="3">
            <v-card>
              <v-card-title>Settings</v-card-title>
              <v-card-subtitle>comp_CurrentKlantConfig</v-card-subtitle>
              <v-card-text>
                <pre>{{ comp_CurrentKlantConfig }}</pre>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="3">
            <v-card>
              <v-card-title>Bedrijf settings</v-card-title>
              <v-card-subtitle>settingsBedrijf</v-card-subtitle>
              <v-card-text>
                <pre>{{ settingsBedrijf }}</pre>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!--        <hr/>-->
        <!--        <pre class="ma-4">Sjabloon (settingsArtikelen): {{ settingsArtikelen }}</pre>-->
        <!--        <hr/>-->
        <!--        <pre class="ma-4">Sjabloon (settingsSjabloon): {{ settingsSjabloon }}</pre>-->
        <!--        <hr/>-->
        <!--        <pre class="ma-4">Sjabloon (settingsSjabloonDialog): {{ settingsSjabloonDialog }}</pre>-->
        <!--        <hr/>-->
        <!--        <pre class="ma-4">Omzetgroepen (settingsOmzetgroepen): {{ settingsOmzetgroepen }}</pre>-->
        <!--        <hr/>-->
        <!--        <pre class="ma-4">Laatste orders (settingsLaatsteVerkooporders): {{ settingsLaatsteVerkooporders }}</pre>-->
        <!--        <hr/>-->
        <!--        <pre class="ma-4">Process status (settingsProcessStatus): {{ settingsProcessStatus }}</pre>-->
        <!--        <hr/>-->
        <!--        <pre class="ma-4">Settings bedrijf (settingsBedrijf): {{ settingsBedrijf }}</pre>-->
        <hr/>
        <pre class="ma-4">Zoekbare velden (m_searchFieldsList): {{ m_searchFieldsList() }}</pre>
        <!--        <hr/>-->
        <!--        <pre class="ma-4">Extravelden (settingsExtraveldenHoofdForm): {{ settingsExtraveldenHoofdForm }}</pre>-->
        <!--        <hr/>-->
        <!--        <pre class="ma-4">Filter setting (settingsFilterInToolbar): {{ settingsFilterInToolbar }}</pre>-->
        <hr/>
        <pre class="ma-4">Table header (comp_mainTableHeader): {{ comp_mainTableHeader }}</pre>
        <!--        <hr/>-->
        <!--        <pre class="ma-4">Extravelden hoofd (settingsExtraveldenHoofdForm): {{ settingsExtraveldenHoofdForm }}</pre>-->
        <!--        <hr/>-->
        <!--        <pre class="ma-4">Extravelden hoofd init (settingsExtraveldenHoofdForm_Init): {{-->
        <!--            settingsExtraveldenHoofdForm_Init-->
        <!--          }}</pre>-->

        <v-row class="ma-1">
          <v-autocomplete
              label="Variabels"
              :items="Object.keys($data)"
              v-model="testVariable"
          ></v-autocomplete>
        </v-row>
        <v-row class="ma-1">
          <v-card class="pa-1">
            <v-card-text>
              <pre
                  v-if="testVariable"
              >{{ $data[testVariable] }}
              </pre>
            </v-card-text>
          </v-card>
        </v-row>
      </div>

    </v-card>
  </v-container>
</template>

<!--
 .d8888b.                   d8b          888
d88P  Y88b                  Y8P          888
Y88b.                                    888
 "Y888b.    .d8888b 888d888 888 88888b.  888888
    "Y88b. d88P"    888P"   888 888 "88b 888
      "888 888      888     888 888  888 888
Y88b  d88P Y88b.    888     888 888 d88P Y88b.
 "Y8888P"   "Y8888P 888     888 88888P"   "Y888
                                888
                                888
                                888
-->
<script lang="js"> // ??ts
import {mixin as VueTimers} from "vue-timers";
import {mapActions, mapGetters} from "vuex";
import common from "../utils/common";
import axios from "axios";
import {v4 as uuidV4} from 'uuid';

// Static import for toolbar filter
import {VSelect, VAutocomplete} from 'vuetify/lib';

import {
  processStatusIconList,
  processStatusSearchList,
  processStatusListEnabled,
  processStatusList,
  processStatusListFilter,
} from '@/utils/constants';

export default {
  name: "Bestelling",

  components: {VSelect, VAutocomplete},

  mixins: [VueTimers],

  // vue-timers module https://www.npmjs.com/package/vue-timers
  timers: {
    m_RunTimerUpdate: {
      time: 60000,
      repeat: true,
      autostart: true,
    }
  },

  // ██████╗  █████╗ ████████╗ █████╗
  // ██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗
  // ██║  ██║███████║   ██║   ███████║
  // ██║  ██║██╔══██║   ██║   ██╔══██║
  // ██████╔╝██║  ██║   ██║   ██║  ██║
  // ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝

  data() {
    return {
      // Test cards
      defColors: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      cards: [
        {title: 'Primary', value: 'primary'},
        {title: 'Secondary', value: 'secondary'},
        {title: 'Accent', value: 'accent'},
        {title: 'Error', value: 'error'},
        {title: 'Info', value: 'info'},
        {title: 'Success', value: 'success'},
        {title: 'Warning', value: 'warning'},
      ],

      // Zoekterm
      search: '',
      searchDelay: '',
      searchTimeoutID: null,
      extendedSearch: true,

      // selected: [],

      // Tips is zichtbaar
      tips: false,

      // Order preview mode: Omzetgroep kiezer is uit, allen toegevoegde artikelen zichtbaar
      previewMode: false,

      // Expanded Dialog in main table
      mainTableExpandedFormModel: true,
      mainTableExpandedFormExpandedList: [],

      // Dialog met aantal artikelen is zichtbaar
      artikelDialog: false,

      // Settings dialog
      settingsDialogModel: false,
      settingsActiefTab: 0,

      // Nep EAN-code om order te sturen
      orderEnterEANCode: '9999999999999',

      testVariable: null,

      //  .d8888b.                     .d888 d8b                                    888    d8b
      // d88P  Y88b                   d88P"  Y8P                                    888    Y8P
      // 888    888                   888                                           888
      // 888         .d88b.  88888b.  888888 888  .d88b.  888  888 888d888  8888b.  888888 888  .d88b.
      // 888        d88""88b 888 "88b 888    888 d88P"88b 888  888 888P"       "88b 888    888 d8P  Y8b
      // 888    888 888  888 888  888 888    888 888  888 888  888 888     .d888888 888    888 88888888
      // Y88b  d88P Y88..88P 888  888 888    888 Y88b 888 Y88b 888 888     888  888 Y88b.  888 Y8b.
      //  "Y8888P"   "Y88P"  888  888 888    888  "Y88888  "Y88888 888     "Y888888  "Y888 888  "Y8888
      //                                              888
      //                                         Y8b d88P
      //                                          "Y88P"

      /**
       * INIT
       * - m_InitKlantSettingsGegevens - Init alle gegevens na klant gegevens te lezen
       * PACK
       * - settingsDialogModel(true) - lees setting naar Dialog
       * UNPACK
       * - m_saveSettingsDialog - Dialog settings naar App settings
       *
       */

      // Model
      customConfiguratie: {
        customField: true,
      },

      settingsAlgemeen: {
        readOnly: false,
        hidePreview: false,
        showBestelformulierInstellingen: true,
        defaultOrderOmschrijving: null
      },
      settingsAlgemeen_Init: {
        readOnly: false,
        hidePreview: false,
        showBestelformulierInstellingen: true,
        defaultOrderOmschrijving: null
      },

      // Settings van Bestelling formulier
      settingsBedrijf: {
        selected: []
      },
      settingsBedrijf_Init: {
        hideWidget: true,
        options: [],
        optionsNames: [
          "hideWidget"
        ],
        readOnly: false,
        selected: [],   // Lijst met UUID's
      },
      settingsBedrijfDialog: {
        // hideWidget: false,
        // options: [],
        // readOnly: false,
        selected: [],   // Lijst met UUID's
      },

      // Artikelen lijst
      settingsArtikelen: {},
      settingsArtikelen_Init: {
        readOnly: false,
        fieldFilters: [],
        // hideWidget: false,
        // hideOmschrijving: false,
        // options: [],
        // optionsNames: [
        //   "hideWidget",
        //   "hideOmschrijving",
        // ],
        // readOnly: false,
        // selected: [],
      },
      settingsArtikelenDialog: {},
      settingsArtikelenDialogIndex: 0,
      settingsArtikelenDialogRules: {
        indexLimit: v => v < this.comp_ArtikelenFromCurAdm.length,
        positief: v => v >= 0
      },

      // Verkoopsjabloon lijst
      settingsSjabloon: {},
      settingsSjabloon_Init: {
        hideWidget: false,
        hideLeeg: false,
        options: [],      // Optie voor visual
        optionsNames: [
          "hideWidget",   // #0 - Hide widget
          "hideLeeg",     // #1 - Hide 'leeg' sjabloon
        ],
        readOnly: false,  // Dialog is read only
        selected: [],     // Lijst met UUID's selected sjablonen
      },
      settingsSjabloonDialog: {
        // hideWidget: false,
        // hideLeeg: false,
        // options: [],
        // readOnly: false,
        selected: [],
      },

      settingsProcessStatus: {},
      settingsProcessStatus_Init: {
        hideWidget: false,
        hideOmschrijving: false,
        options: [],
        optionsNames: [
          "hideWidget",
          "hideOmschrijving",
        ],
        readOnly: false,
        selected: [],
      },
      settingsProcessStatusDialog: {
        hideWidget: false,
        options: [],
        readOnly: false,
        selected: [],
      },

      settingsOmzetgroepen: {},
      settingsOmzetgroepen_Init: {
        hideWidget: false,
        options: [],
        optionsNames: [
          "hideWidget"
        ],
        readOnly: false,
        selected: [],
      },
      settingsOmzetgroepenDialog: {
        // hideWidget: false,
        // options: [],
        // readOnly: false,
        selected: [],
      },

      // Laatste verkooporders filter
      settingsLaatsteVerkooporders: {},
      settingsLaatsteVerkooporders_Init: {
        readOnly: false,
        selected: [],
      },
      settingsLaatsteVerkoopordersDialog: {
        // readOnly: false,
        selected: [],
      },

      settingsExpandForm: {
        show: false,
        fields: [],
      },
      settingsExpandForm_Init: {
        show: false,
      },

      // Extravelden tussen omschrijving en aantal in hoofd formulier
      settingsExtraveldenHoofdForm: [],

      // TODO: Error: Met _Init, Array gaat naar Object!
      settingsExtraveldenHoofdForm_Init: [],

      // Filter block in Toolbar
      settingsFilterInToolbar: {
        filters: []
      },

      // settingsFilterInToolbar: {
      //   visibleFilter: true,
      //   hideFilters: false,
      //   filters: [
      //     {
      //       label: 'Board color',
      //       component: 'VAutocomplete',
      //       prependIcon: 'mdi-filter-outline',
      //       fieldName: 'extra_velden_BoardColor',
      //       model: null,
      //       multiple: true,
      //       chips: false,
      //       clearable: true,
      //       cols: 3,
      //     },
      //     {
      //       label: 'Artikelcode',
      //       prependIcon: 'mdi-filter-outline',
      //       fieldName: 'artikelcode',
      //       model: null,
      //       multiple: true,
      //       chips: true,
      //       clearable: true,
      //       cols: 2,
      //     }
      //   ]
      // },

      settingsFilterInToolbar_Init: {
        hideFilters: true,
        visibleFilter: false,
        filters: [],
      },

      settingsVoorraadIndicator: {},
      settingsVoorraadIndicator_Init: {
        show: false,            // Voorraad indicator aan
        tooltip: true,
        widget: "default",      // "default" - kleur rond, "digit" - cijfers
        label: "Vrd",
        default_red_level: 0,   // <= - RED
        default_green_level: 5, // >= - GREEN
        // red_level_extraveld: 'extra_velden_RedLevel',
        // green_level_extraveld: 'extra_velden_GreenLevel',
      },

      settingsSignature: {
        signPadShow: true,
      },

      settingsSignature_Init: {
        signPadShow: true,
      },

      settingsTabItems: null,
      settingsTabItems_Init: [
        "Bedrijf",
        "Sjabloon",
        "Omzetgroepen",
        "Laatste orders",
        "Process status",
        "Zending info",
        "Artikelen",
        "Algemeen",
      ],

      // Zending in Progress
      inProgressSend: false,
      inProgressLoad: false,

      // Bedrijf/adres lijst
      bedrijfLijstSelected: null,
      bedrijfInput: null,

      // Icons lijst voor
      processStatusIconList,
      // constants export
      processStatusList,
      processStatusListEnabled,
      // Voor filtering, alle items ingeschakeld
      processStatusListFilter,
      processStatusSearchList,

      geblokkeerdListFilter: [
        {
          id: 0, text: "<Alle>",
          icon: 'mdi-lock-question',
        },
        {
          id: 1, text: "Geblokkeerd",
          icon: 'mdi-lock',
        },
        {
          id: 2, text: "Gedeblokkeerd",
          icon: 'mdi-lock-open-variant-outline',
        },
        // {
        //   id: 3, text: "Onbekend",
        //   icon: 'mdi-lock-question',
        // },
      ],

      // Default status
      processStatusName: null,

      currentSjabloonId: null,

      laatsteOrderDialogFilters: {
        processStatus: null,
        processStatusLijstModel: 0,
        geblokkeerdListModel: 0,
      },

      laatsteOrderZoeken: '',
      laatsteOrderDialog: false,
      laatsteOrderModel: 0,
      laatsteOrderSearchInput: '',
      // true tijdens laatste order toevoegen
      laatsteOrderInProgress: false,

      /*
       *  888                   888             888                                         888
       *  888                   888             888                                         888
       *  888                   888             888                                         888
       *  888  8888b.   8888b.  888888 .d8888b  888888  .d88b.         .d88b.  888d888  .d88888  .d88b.  888d888
       *  888     "88b     "88b 888    88K      888    d8P  Y8b       d88""88b 888P"   d88" 888 d8P  Y8b 888P"
       *  888 .d888888 .d888888 888    "Y8888b. 888    88888888       888  888 888     888  888 88888888 888
       *  888 888  888 888  888 Y88b.       X88 Y88b.  Y8b.           Y88..88P 888     Y88b 888 Y8b.     888
       *  888 "Y888888 "Y888888  "Y888  88888P'  "Y888  "Y8888         "Y88P"  888      "Y88888  "Y8888  888
       *
       *  888                             888
       *  888                             888
       *  888                             888
       *  88888b.   .d88b.   8888b.   .d88888  .d88b.  888d888
       *  888 "88b d8P  Y8b     "88b d88" 888 d8P  Y8b 888P"
       *  888  888 88888888 .d888888 888  888 88888888 888
       *  888  888 Y8b.     888  888 Y88b 888 Y8b.     888
       *  888  888  "Y8888  "Y888888  "Y88888  "Y8888  888
       */
      laatsteOrderHeader: [
        // { HEADER FORMAAT:
        //   text: string,
        //   value: string
        //   align?: 'start' | 'center' | 'end',
        //   sortable?: boolean,
        //   filterable?: boolean,
        //   divider?: boolean,
        //   class?: string | string[],
        //   width?: string | number,
        //   filter?: (value: any, search: string, item: any) => boolean,
        //   sort?: (a: any, b: any) => number,
        // }
        // {text: 'ID', value: 'id', sort: Number},
        {
          text: "Stat",
          value: "order_status",
        },
        {
          text: "Order #",
          value: "nummer",
          sort: Number,
        },
        {
          text: "Datum",
          value: "datum",
        },
        {
          text: "Omschrijving",
          value: "omschrijving",
        },
        {
          text: "Totaal ex.",
          value: "totaal_exclusief_btw",
          align: 'end',
          divider: true,
        },
        {
          text: 'Actie',
          value: 'actions',
          // width: '0em',
          sortable: false,
          filterable: false,
          divider: true,
        },
        {
          text: 'Regels',
          value: 'data-table-expand'
        },
      ],

      // Knoppen met aantal toevoegen in dialog venster
      btnAantalToevoegen: [50, 20, 10, 5, 3],

      // Aantal artikelen in winkelwagentje
      // comp_BasketCount: 0.0,

      omzetgroepID: 0,

      // data table gegevens
      dataTablePage: 1,
      dataTableItemsPerPage: 18,
      settingsFooterTable: {
        'items-per-page-options': [6, 12, 18, 30, 100],
        'items-per-page-text': 'Artikelen per pagina:'
      },

      // Hoofd tabel voor
      mainTableBefore: [
        {
          text: 'Code',
          value: 'artikelcode',
        },
        // {text: 'Omzetgroep', value: 'omzetgroep.omschrijving',},
        {
          text: 'Omschrijving',
          value: 'omschrijving',
        },
      ],

      // Voorraad veld
      mainTableVoorraad: [
        {
          text: 'Vrd',
          value: 'vrije_voorraad',
          align: 'center',
          sortable: true,
        },
      ],

      // Hoofd tabel achter
      mainTableAfter: [
        {
          text: 'Aantal',
          value: 'basket',
          width: '20em',
          align: 'center',
        },
        {
          text: 'Actie',
          value: 'actions',
          width: '10em',
          sortable: false,
          filterable: false,
        },
      ],

      mainTableLastField: [
        {
          text: 'Ext',
          value: 'data-table-expand',
          sortable: false,
          filterable: false,
          align: 'center',
        },
      ],

      // Extra zoekvelden, kommen van portal instellingen
      settingsZoekvelden: [],

      // Settings om 'Search' velden uit te filteren
      settingsDisabledSearchFields: [
        'actions',
        'basket',
        'vrije_voorraad',
        'data-table-expand',
      ],

      // Basket bewerken
      editedIndex: -1,
      editedItem: {
        artikelcode: '',
        omschrijving: '',
        eenheid: '',
        basket: 0,
      },

      // DEBUG
      // Wheel event
      // wheel: null,
      // Som van Delta Y
      // whellDeltaYSum: 0,

      switch: "v-switch",
      colormap: {
        pastel: [
          "#F2F2F2",
          "#CCEBC5",
          "#FFFFCC",
          "#FBB4AE",
          "#DECBE4",
          "#E5D8BD",
          "#FDDAEC",
          "#B3CDE3",
          "#FED9A6",
        ],
        paired: [
          "#C0C0C0",
          "#A6CEE3",
          "#B2DF8A",
          "#FB9A99",
          "#FDBF6F",
          "#CAB2D6",
          "#FFFF99",
          "#5784BA",
          "#E7CBA9",
          "#C54B6C",
          "#FF7F00",
          "#98D4BB",
          "#9C9359",
        ]
      },

      // Order zending dialog...
      orderDialog: false,
      orderOmschrijving: '',
      orderMemo: '',
      selectedRelatieIDInLastOrdersDialog: null,
      // orderPreviewPanel: [0],

      // Artikel dialog
      clipboardMessage: '',
      clipboardColor: '',
      showClipboardMessage: false,

      // Sign Pad
      padOptions: {
        penColor: "black",
        onBegin: () => {
          this.$refs.signaturePad.resizeCanvas()
        },
      },
      signData: null,
      signNeed: false,
      signToolFab: false,

    } // return
  }, // data

  /**

   .d8888b.   .d88888b.  888b     d888 8888888b.  888     888 88888888888 8888888888 8888888b.
   d88P  Y88b d88P" "Y88b 8888b   d8888 888   Y88b 888     888     888     888        888  "Y88b
   888    888 888     888 88888b.d88888 888    888 888     888     888     888        888    888
   888        888     888 888Y88888P888 888   d88P 888     888     888     8888888    888    888
   888        888     888 888 Y888P 888 8888888P"  888     888     888     888        888    888
   888    888 888     888 888  Y8P  888 888        888     888     888     888        888    888
   Y88b  d88P Y88b. .d88P 888   "   888 888        Y88b. .d88P     888     888        888  .d88P
   "Y8888P"   "Y88888P"  888       888 888         "Y88888P"      888     8888888888 8888888P"

   */
  // COMPUTED
  computed: {
    // Gegevens bronnen
    ...mapGetters({
      app_GetRootApiUri: "app/GET_ROOT_API_URI",
      GET_TIPS: "app/GET_TIPS",

      ss_GetArtikelenLijst: "snelstart/GET_ARTIKELEN",
      ss_GetArtikelenProgress: "snelstart/GET_ARTIKELEN_PROGRESS",

      ss_GetKlantenLijst: "snelstart/GET_KLANTEN",
      ss_GetKlantenProgress: 'snelstart/GET_RELATIES_PROGRESS',

      ss_GetSjablonenLijst: "snelstart/GET_ORDER_SJABLONEN",
      ss_GetSjablonenProgress: 'snelstart/GET_SJABLONEN_PROGRESS',

      ss_GetVerkoopOrdersLijst: "snelstart/GET_VERKOOP_ORDERS",
      ss_GetVerkoopOrdersProgress: "snelstart/GET_VERKOOP_PROGRESS",

      ss_GetGlobalProgressFlag: "snelstart/GET_GLOBAL_PROGRESS_FLAG",

      user_GetCurrentOperator: "user/GET_OPERATOR",
      user_GetCurrentSnelStart: "user/GET_CURRENT_SNELSTART",

      user_GetCurrentProfiel: "user/GET_CURRENT_PROFIEL",

      appDevMessages: "app/GET_DEV_MESSAGES",
      appGuiCompact: "app/GET_GUI_COMPACT",

      // user_GetKlantgegevensLijst: "user/GET_KLANTGEGEVENS_LIST",
      // currentModule: "user/GET_CURRENT_MODULE",
    }),

    // comp_BestellingContainerHeight() {
    //   let h = 1000
    //   const el = document.getElementById('bestelling-container')
    //   console.log('Container:', el)
    //
    //   if (el) {
    //     h = el?.clientHeight
    //   }
    //   console.log('Container height:', h)
    //
    //   return h
    // },

    // comp_GlobalProgress() {
    //   return this.ss_GetArtikelenProgress.loading
    //       || this.ss_GetKlantenProgress.loading
    // },

    comp_ArtikelenFromCurAdm() {
      return this.ss_GetArtikelenLijst
          .filter(i => i.snelstart_id === this.user_GetCurrentSnelStart.id)
          .filter(i => i.actief)
    },

    comp_ArtikelenFromCurAdmWithFilterPlusFormFilter() {
      return this.m_ArtikelenHoofdFormFilter(this.comp_ArtikelenFromCurAdmWithFilter)
    },

    comp_ArtikelenFromCurAdmWithFilter() {
      return this.m_ArtikelenFieldFilter(this.comp_ArtikelenFromCurAdm)
    },

    comp_ArtikelenInBasket() {
      console.log('comp_ArtikelenInBasket(), comp_ArtikelenFromCurAdmWithFilter =', this.comp_ArtikelenFromCurAdmWithFilter)
      return this.comp_ArtikelenFromCurAdmWithFilter.filter((i) => i.basket)
    },

    comp_ArtikelenToolbarFilters() {
      if (this.previewMode) {
        return this.comp_ArtikelenInBasket
      } else {
        if (this.prop_OmzetgroepID !== 0) {
          return this.comp_ArtikelenFromCurAdmWithFilterPlusFormFilter.filter((i) => i.omzetgroep.id === this.prop_OmzetgroepID)
        } else {
          return this.comp_ArtikelenFromCurAdmWithFilterPlusFormFilter
        }
      }
    },

    // Is gewone zoek of uitgebreid
    comp_extendedSearch() {
      return this.extendedSearch && this.searchDelay && this.searchDelay.includes('/')
    },

    comp_ArtikelenToolbarFiltersEnZoeken() {
      if (this.comp_extendedSearch) {
        // const velden = [
        //   'artikelcode',
        //   'omschrijving',
        // ]
        const velden = this.m_searchFieldsList()  // comp_searchFieldsList

        const searchTerms = this.searchDelay.split('/')
            .filter((i) => i.length > 0)
            .map((i) => i.toLowerCase())

        console.log('searchTerms=', searchTerms)

        // Zoeken in alle 'toolbar' artikelen
        return this.comp_ArtikelenToolbarFilters.filter((item4filter) => {
          let veldenValues = ''
          // velden.forEach((f) => veldenValues += ' ' + item4filter[f].toString().toLowerCase())

          for (const field of velden) {
            let val = item4filter[field]
            if (val) {
              veldenValues += ' ' + val.toString().toLowerCase()
            }
          }

          // console.log('veldenValues=', veldenValues)

          for (const searchTerm of searchTerms) {
            if (!veldenValues.includes(searchTerm)) {
              return false
            }
          }
          // console.log('Terms =', searchTerms)
          // console.log('CombiVeld =', veldenValues)
          return true
        })
      } else {
        return this.comp_ArtikelenToolbarFilters
      }
    },

    comp_FilteredSjablonen() {
      // Dialog is open, geen filter

      // Filter op geselecteerde administratie
      let filteredOpSnelStart = this.ss_GetSjablonenLijst
          .filter((i) => i.actief && i.snelstart_id === this.user_GetCurrentSnelStart.id)

      // Is configuratie filter actief?
      const isSjablonenSelected = Array.isArray(this.settingsSjabloon.selected) &&
          this.settingsSjabloon.selected.length > 0

      // Setting dialog aan of niks geselecteerd
      if (!(this.settingsDialogModel || !isSjablonenSelected)) {
        // Geen dialog en iets geselecteerd
        filteredOpSnelStart = filteredOpSnelStart
            .filter((i) => this.settingsSjabloon.selected.includes(i.uuid))
      }

      // Filter 'Leeg'
      // Config dialog dicht
      if (!this.settingsDialogModel) {
        // Optie 'Hide' is aan en aantal Sjablonen > 1
        if (this.settingsSjabloon.hideLeeg && filteredOpSnelStart.length > 1) {
          filteredOpSnelStart = filteredOpSnelStart.filter((i) => i.omschrijving !== 'Leeg')
        }
      }

      return filteredOpSnelStart
    },

    comp_VerkoopOrdersFromCurAdm() {
      return this.ss_GetVerkoopOrdersLijst
          .filter((i) => i.snelstart_id === this.user_GetCurrentSnelStart.id)
          .filter((i) => i.nummer !== null)
    },

    comp_FilteredVerkoopOrders() {
      let bedrijfSelectedID = 0
      let filteredOrders = this.comp_VerkoopOrdersFromCurAdm

      if (this.bedrijfLijstSelected) {
        // Bedrijf van top select lijst
        bedrijfSelectedID = this.bedrijfLijstSelected.id
      } else if (this.comp_FilterKlantenMetConfiguratie.length === 1) {
        // Eerste bedrijf van Klanten configuratie
        bedrijfSelectedID = this.comp_FilterKlantenMetConfiguratie[0].id
      }

      if (bedrijfSelectedID !== 0) {
        filteredOrders = filteredOrders.filter((i) => i.relatie_id === bedrijfSelectedID)
      }

      // Lijst met selecteerde statuses
      const sel = this.settingsLaatsteVerkooporders.selected
      // Alle statuses
      const psl = this.processStatusSearchList
      if (Array.isArray(sel) && sel.length > 0) {
        filteredOrders = filteredOrders.filter((i) => sel.includes(psl[i.order_status]))
      }

      return filteredOrders
    },

    comp_VerkoopOrdersInLastOrdersDialogFilteredExcludeStatus() {
      // let orders = Object.assign({}, this.comp_FilteredVerkoopOrders)
      let orders = this.comp_FilteredVerkoopOrders

      // Filter orders op geselecteerde bedrijf
      if (this.selectedRelatieIDInLastOrdersDialog) {
        // console.log('Selected Relatie in Order Dialog:', this.selectedRelatieIDInLastOrdersDialog)
        orders = orders.filter(
            i => i.relatie_id === this.selectedRelatieIDInLastOrdersDialog
        )
      }

      // Process Status Filteren
      // if (this.laatsteOrderDialogFilters.processStatusLijstModel !== 0) {
      //   orders = orders.filter(
      //       i => i.order_status === this.laatsteOrderDialogFilters.processStatusLijstModel
      //   )
      // }

      // Blokkade filteren: 0 - Alles => geen filter
      if (this.laatsteOrderDialogFilters.geblokkeerdListModel !== 0) {
        // 1 - Geblokkeerd / 2 - Gedeblokkeerd of undef
        orders = orders.filter(
            (i) => i.get_meta && i.get_meta.geblokkeerd && (i.get_meta.geblokkeerd !== (this.laatsteOrderDialogFilters.geblokkeerdListModel === 2))
        )
      }
      return orders
    },

    comp_VerkoopOrdersInLastOrdersDialogFiltered() {
      // let orders = Object.assign({}, this.comp_FilteredVerkoopOrders)
      let orders = this.comp_VerkoopOrdersInLastOrdersDialogFilteredExcludeStatus

      // Process Status Filteren
      if (this.laatsteOrderDialogFilters.processStatusLijstModel !== 0) {
        orders = orders.filter(
            i => i.order_status === this.laatsteOrderDialogFilters.processStatusLijstModel
        )
      }

      return orders
    },

    comp_RelatiesInLastOrdersDialog() {
      // Alle Relatie/Klanten die voor Order dialog hoort.
      // DropDown list on Laatste order dialog

      // Maken lijst met ALLE relatie ID's van VerkoopOrders
      let relatieIds = new Set(
          // this.comp_VerkoopOrdersInLastOrdersDialogFiltered.map((i) => i.relatie_id)
          this.comp_FilteredVerkoopOrders.map((i) => i.relatie_id)
      )
      // console.log('Rel IDs', relatieIds)
      return this.comp_KlantenCurAdm.filter((i) => relatieIds.has(i.id))
    },

    comp_KlantenCurAdm() {
      return this.ss_GetKlantenLijst.filter((i) => i.snelstart_id === this.user_GetCurrentSnelStart.id)
    },

    comp_FilterKlantenMetConfiguratie() {
      if (this.settingsBedrijf.selected.length > 0) {
        return this.comp_KlantenCurAdm.filter((i) => this.settingsBedrijf.selected.includes(i.uuid))
      } else {
        return this.comp_KlantenCurAdm
      }
    },

    comp_BasketCount() {
      const art = this.ss_GetArtikelenLijst.filter((i) => i.snelstart_id === this.user_GetCurrentSnelStart.id)
      // array.reduce(function(total, currentValue, currentIndex, arr), initialValue)
      let art_count = art.reduce((t, c) => t + c.basket, 0)
      // NAN -> 0
      if (isNaN(art_count)) return 0
      // Int -> count
      if (Number.isInteger(art_count)) return art_count
      // Float -> Fixed(2)
      return art_count.toFixed(2)
    },

    comp_OmzetgroepenExAll() {
      const artikelen = this.ss_GetArtikelenLijst.filter((i) => i.snelstart_id === this.user_GetCurrentSnelStart.id)
      const omzetgroeppenID = [...new Set(artikelen.map(item => item.omzetgroep.id))]

      // console.log('Comp OG ID:', omzetgroeppenID)
      let omzetgroeppen = []
      for (let omID of omzetgroeppenID) {
        const idx = artikelen.findIndex(art => art.omzetgroep.id === omID)
        omzetgroeppen.push(artikelen[idx].omzetgroep)
      }
      omzetgroeppen.sort((a, b) => (a.omschrijving > b.omschrijving ? 1 : -1))
      return omzetgroeppen
    },

    comp_Omzetgroepen() {
      let omzetgroeppen = [...this.comp_OmzetgroepenExAll]

      // In begin + <Alles>
      omzetgroeppen.unshift({id: 0, omschrijving: '<Alles>',})

      return omzetgroeppen
    },

    comp_OmzetgroepenFiltered() {
      let omzetgroepen = [...this.comp_Omzetgroepen]
      if (this.settingsOmzetgroepen?.selected
          && Array.isArray(this.settingsOmzetgroepen.selected)
          && this.settingsOmzetgroepen.selected.length > 0) {
        return omzetgroepen.filter(i => this.settingsOmzetgroepen.selected.includes(i.uuid))
      }
      return omzetgroepen
    },

    comp_ProcessStatusFiltered() {
      if (this.settingsProcessStatus?.selected
          && Array.isArray(this.settingsProcessStatus.selected)
          && this.settingsProcessStatus.selected.length > 0) {
        return this.processStatusList.filter(i => this.settingsProcessStatus.selected.includes(i.text))
      } else {
        return this.processStatusList
      }
    },

    comp_GetSearchColor() {
      if (this.search) {
        return this.$vuetify.theme.dark ? 'blue-grey darken-3' : 'blue-grey lighten-5'
      }
      return ''
    },

    /**
     *                        888               888     888                  888
     *                        888               888     888                  888
     *                        888               888     888                  888
     * 88888b.d88b.   8888b.  888  888  .d88b.  Y88b   d88P  .d88b.  888d888 888  888  .d88b.   .d88b.  88888b.
     * 888 "888 "88b     "88b 888 .88P d8P  Y8b  Y88b d88P  d8P  Y8b 888P"   888 .88P d88""88b d88""88b 888 "88b
     * 888  888  888 .d888888 888888K  88888888   Y88o88P   88888888 888     888888K  888  888 888  888 888  888
     * 888  888  888 888  888 888 "88b Y8b.        Y888P    Y8b.     888     888 "88b Y88..88P Y88..88P 888 d88P
     * 888  888  888 "Y888888 888  888  "Y8888      Y8P      "Y8888  888     888  888  "Y88P"   "Y88P"  88888P"
     *                                                                                                  888
     *                                                                                                  888
     *                          888
     *  .d88888b.               888                  888b     d888
     * d88P" "Y88b              888                  8888b   d8888
     * 888     888              888                  88888b.d88888
     * 888     888 888d888  .d88888  .d88b.  888d888 888Y88888P888  .d88b.  88888b.  888  888
     * 888     888 888P"   d88" 888 d8P  Y8b 888P"   888 Y888P 888 d8P  Y8b 888 "88b 888  888
     * 888     888 888     888  888 88888888 888     888  Y8P  888 88888888 888  888 888  888
     * Y88b. .d88P 888     Y88b 888 Y8b.     888     888   "   888 Y8b.     888  888 Y88b 888
     *  "Y88888P"  888      "Y88888  "Y8888  888     888       888  "Y8888  888  888  "Y88888
     **/

    comp_MakeVerkoopOrderMenu() {
      // laatsteOrderLijst: [
      //   {id: 1, text: 'Order 123'},
      //   {header: 'Order regel 127'},
      //   {header: 'Order regel 128'},
      //   {divider: true},
      //   {id: 3, text: 'Oder 124'},
      //   {header: 'Order regel 126',},
      //   // {divider: true},
      // ],

      //  1 Beginnen van leeg menu
      const menu = []
      if (this.comp_FilteredVerkoopOrders.length > 0) {

        // 2 Copy & Sort
        const filteredVerkoopOrdersSorted = [...this.comp_FilteredVerkoopOrders].sort(
            (a, b) => b.nummer - a.nummer   // -n, 0, +n
        )

        // 3 For alle orders
        filteredVerkoopOrdersSorted.forEach(order => {

          // 3.1 Order divider
          if (menu.length !== 0) {
            menu.push({divider: true})
          }

          let orderDatum = ''

          // 3.2 ISO datum naar locale datum converteren
          try {
            orderDatum = new Date(Date.parse(order.datum))
                .toLocaleDateString(
                    'nl',
                    {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })
          } catch (e) {
            console.log(`[${order.datum}] heeft verkeerd datum format: ${e}`)
          }

          // 3.3 Order #, datum en omschrijving
          const status_index = (order.order_status > 0 && order.order_status <= 8) ? order.order_status : 0
          menu.push({
            id: order.id,
            text: `id: ${order.id}, ${this.processStatusSearchList[status_index]}: #${order.nummer}, ${orderDatum} ${order.omschrijving}`.trim(),
          })

          // 3.4 Artikelen in lijst
          if ('regels' in order && Array.isArray(order.regels) && order.regels.length > 0) {
            order.regels.forEach(regel => {
                  // 3.4.1 Zoeken binnen ALLE artikelen, id moet uniek zijn!!
                  const artikel = this.ss_GetArtikelenLijst.find(a => a.id === regel.artikel_id)

                  // 3.4.2 Add to menu
                  if (artikel) {
                    menu.push({header: `${regel.aantal}, [${artikel.artikelcode}] ${regel.omschrijving}`})
                  } else {
                    menu.push({header: `${regel.aantal}, [geen artikel] ${regel.omschrijving}`})
                  }

                }
            ) // for Each regels
          }  // if regels in order
        })  // for Each orders
      } // if
      // 4 Menu lijst terug geven
      return menu
    },

    /**
     *                                          888    d8P  888                   888
     *                                          888   d8P   888                   888
     *                                          888  d8P    888                   888
     * 88888b.d88b.   .d88b.  88888b.  888  888 888d88K     888  8888b.  88888b.  888888  .d88b.  88888b.
     * 888 "888 "88b d8P  Y8b 888 "88b 888  888 8888888b    888     "88b 888 "88b 888    d8P  Y8b 888 "88b
     * 888  888  888 88888888 888  888 888  888 888  Y88b   888 .d888888 888  888 888    88888888 888  888
     * 888  888  888 Y8b.     888  888 Y88b 888 888   Y88b  888 888  888 888  888 Y88b.  Y8b.     888  888
     * 888  888  888  "Y8888  888  888  "Y88888 888    Y88b 888 "Y888888 888  888  "Y888  "Y8888  888  888
     **/

    comp_MenuKlanten() {
      /* Maken Bedrijven menu met volgende structuur:
      *   [
      *     { header: "Adres van bedrijf" },
      *     {
      *       id: 0000,                                     // Portal ID van relatie: int
      *       naam: "Naam van relatie/bedrijf",
      *       text: "1289: De Implementatie Partners B.V.", // "relatiecode: Naam"
      *       uuid: "12345678-1234-..."                     // SnelStart UUID
      *     },
      *     { divider: true },
      *     ...
      * */

      // 1 Beginnen van leeg menu
      const menu = []
      if (this.comp_FilterKlantenMetConfiguratie.length > 0) {

        // 2 Copy & Sort
        const filteredKlantenSorted = [...this.comp_FilterKlantenMetConfiguratie].sort(
            (a, b) => { // b.naam < a.naam   // -n, 0, +n
              if (a.naam.trim() > b.naam.trim()) {
                return 1
              }
              if (a.naam.trim() < b.naam.trim()) {
                return -1
              }
              return 0
            }
        )

        // 3 For alle klanten
        filteredKlantenSorted.forEach(klant => {

          // 3.1 Order divider
          if (menu.length !== 0) {
            menu.push({divider: true})
          }

          let adres = ''
          if (klant.vestigings_contactpersoon) {
            adres += klant.vestigings_contactpersoon + ', '
          }
          if (klant.vestigings_straat) {
            adres += `${klant.vestigings_straat}, `
          }
          if (klant.vestigings_postcode) {
            adres += `${klant.vestigings_postcode} `
          }
          if (klant.vestigings_plaats) {
            adres += klant.vestigings_plaats.toUpperCase()
          }

          adres = adres.trim()

          if (adres) {
            menu.push({
              header: adres
            })
          }

          menu.push({
            id: klant.id,
            text: `${klant.relatiecode}: ${klant.naam.trim()}`,
            naam: klant.naam.trim(),
            uuid: klant.uuid,
          })
        })  // for Each klant
      }  // if
      // 4 Menu lijst terug geven
      return menu
    },

    prop_OmzetgroepID: {
      get() {
        if (this.comp_OmzetgroepenFiltered.find(og => og.id === this.omzetgroepID)) {
          return this.omzetgroepID
        } else if (this.comp_OmzetgroepenFiltered.length > 0) {
          return this.comp_OmzetgroepenFiltered[0].id
        }
        return 0
      },

      set(val) {
        this.omzetgroepID = val
      }
    },

    prop_ProcessStatusName: {
      get() {
        // Status mag gebruiken
        if (this.comp_ProcessStatusFiltered.find(ps => ps.text === this.processStatusName)) {
          return this.processStatusName
          // Eerste status die mag gebruiken
        } else if (this.comp_ProcessStatusFiltered.length > 0) {
          return this.comp_ProcessStatusFiltered[0].text
        }
        // Geen statusen in de lijst, toch 'Order' gebruken
        return this.processStatusList[0].text
      },

      set(val) {
        this.processStatusName = val
      }
    },

    prop_CurrentSjabloonID: {
      get() {
        const sj_list = this.comp_FilteredSjablonen

        if (Array.isArray(sj_list) && sj_list.length > 0) {
          // Zoeken Item op ID
          const selectedItem = sj_list.find((i) => i.id === this.currentSjabloonId)
          if (selectedItem) {
            return selectedItem.id
          }

          // Zoeken Item op naam 'Leeg'
          const leegItem = sj_list.find((i) => i.omschrijving === "Leeg")
          if (leegItem) {
            return leegItem.id
          }

          // Eerste selected
          // if (Array.isArray(this.settingsSjabloon.selected)) {
          //   if (this.settingsSjabloon.selected.length > 0) {
          //     return this.settingsSjabloon.selected[0]
          //   }
          // }
          return sj_list[0].id
        }
        return null
      },
      set(val) {
        console.log("Set sjabloon ID =>", val)
        this.currentSjabloonId = val
      }
    },

    comp_CurrentSjabloonName() {
      const sj_list = this.comp_FilteredSjablonen
      const sjabloon = sj_list.find((el) => el.id === this.prop_CurrentSjabloonID)
      return sjabloon?.omschrijving
    },

    comp_CurrentProcessStatus() {
      const statElem = this.processStatusList.find((el) => el.text === this.prop_ProcessStatusName)
      if (statElem) {
        return statElem
      } else {
        return this.processStatusList[0]
      }
    },

    comp_CurrentKlantConfig() {
      return Object.assign(this.customConfiguratie, this.comp_CurrentKlantgegevens)
    },

    comp_CurrentKlantgegevens() {
      /**
       * Get klant gegevens
       */
      if (this.user_GetCurrentOperator?.klant_gegevens?.config) {
        return this.user_GetCurrentOperator?.klant_gegevens?.config
      } else {
        return {error: true}
      }
    },

    comp_isScreenSizeName() {
      return this.$vuetify.breakpoint.name
    },

    comp_ZoekveldUnpack() {
      // console.log('comp_ZoekveldUnpack:')
      // console.log('settingsZoekvelden:', this.settingsZoekvelden)

      let velden = []

      if (Array.isArray(this.settingsZoekvelden)) {
        for (let i in this.settingsZoekvelden) {
          velden.push(
              Object.assign({
                    sortable: false,
                    filterable: true,
                    //
                    align: ' d-none',  // Hide field, Spatie vóór is verplicht!
                    class: 'custom-hide',
                    width: NaN,
                  }, {
                    text: this.settingsZoekvelden[i].replace(/(^extra_velden_)/gi, ""),
                    value: this.settingsZoekvelden[i]
                  }
              )
          )
        }
        // console.log(velden)
      }
      return velden
    },

    comp_mainTableHeader() {
      return [].concat(
          // Hoofd tabel voor
          this.mainTableBefore,
          // Extravelden tussen omschrijving en aantal in hoofd formulier
          this.settingsExtraveldenHoofdForm,
          // Voorraad indicator
          this.settingsVoorraadIndicator.show ? this.mainTableVoorraad : [],
          // Hoofd tabel achter
          this.mainTableAfter,
          // Zoekveld
          this.comp_ZoekveldUnpack,
          // Expand form button
          this.settingsExpandForm.show ? this.mainTableLastField : [],
      )
    },

    comp_ProcessStatusListExcludeEmpty() {
      return this.processStatusListFilter.filter(
          i => i.id === 0 || this.getOrderCountPerStatusID(i.id) > 0
      )
    },

    comp_ArtikelenFieldsList() {
      let basisFields = [
        "artikelcode",
        "omschrijving",
        "inkoopprijs",
        "verkoopprijs",
        "eenheid",
        "voorraad_controle",
        "technische_voorraad",
        "vrije_voorraad",
      ]

      if (this.comp_ArtikelenFromCurAdm.length > 0) {
        for (let fieldName in this.comp_ArtikelenFromCurAdm[0]) {
          if (fieldName.startsWith('extra_velden_')) {
            basisFields.push(fieldName)
          }
        }
      }
      return basisFields
    },

    comp_ArtikelenDialogFiltersList() {
      return [
        "=",
        "?=",
        "!=",
        ">",
        "<",
        ">=",
        "<=",
        "in",
        "?in",
        "not in",
        "true",
        "false",
        "starts with",
        "ends with",
        "contains",
      ]
    }
  }, // computed

  /**

   888b     d888 8888888888 88888888888 888    888  .d88888b.  8888888b.   .d8888b.
   8888b   d8888 888            888     888    888 d88P" "Y88b 888  "Y88b d88P  Y88b
   88888b.d88888 888            888     888    888 888     888 888    888 Y88b.
   888Y88888P888 8888888        888     8888888888 888     888 888    888  "Y888b.
   888 Y888P 888 888            888     888    888 888     888 888    888     "Y88b.
   888  Y8P  888 888            888     888    888 888     888 888    888       "888
   888   "   888 888            888     888    888 Y88b. .d88P 888  .d88P Y88b  d88P
   888       888 8888888888     888     888    888  "Y88888P"  8888888P"   "Y8888P"

   */

  // METHODS
  methods: {
    ...mapActions({
          writeArtikelBasketValue: "snelstart/WRITE_ARTIKEL_BUSKET_VALUE",
        }
    ),

    // copyToClipboard: function (event) {
    //   const {copyElementToClipboard} = common.fn;
    //   copyElementToClipboard(event)
    // },

    async m_VoegLaatsteOrderInBasket(menuItem) {

      console.log('voegLaatsteOrderInBasket()', menuItem)

      if (menuItem) {
        // Zoeken order op menu id
        const order = this.comp_FilteredVerkoopOrders.find(o => o.id === menuItem.id)
        const report = []
        let warning_flag = false

        // Order bestaat en heeft regels
        if (order && 'regels' in order && Array.isArray(order.regels) && order.regels.length > 0) {

          // Close "Laatste Order" dialog
          this.laatsteOrderDialog = false
          // Laatste Order in progress
          this.laatsteOrderInProgress = true

          report.push(`<h4>Order #${order.nummer} is toegevoegd</h4><ul>`)

          for (const regel of order.regels) {
            // 3.4.1 Zoeken binnen ALLE artikelen, id moet uniek zijn!!
            const artikel = this.comp_ArtikelenFromCurAdmWithFilter.find(a => a.uuid === regel.artikel?.uuid)

            if (artikel !== undefined && artikel.actief) {
              if ('aantal' in regel && !Number.isNaN(regel.aantal)) {
                // setTimeout(() => this.$store.dispatch('snelstart/WRITE_ARTIKEL_BUSKET_VALUE', {
                //   id: artikel.id,
                //   value: artikel.basket + regel.aantal,
                // }), 200)
                await this.$store.dispatch('snelstart/WRITE_ARTIKEL_BUSKET_VALUE', {
                  id: artikel.id,
                  value: artikel.basket + regel.aantal,
                })
                report.push(`<li><b>${regel.aantal}</b> [<i>${artikel.artikelcode}</i>] ${artikel.omschrijving}</li>`)
              }
            } else if (regel.omschrijving) {
              report.push(`<li><s>${regel.omschrijving}</s> <b>is niet gevonden</b></li>`)
              warning_flag = true
            }
          } // for regels

          this.addLogBook(
              report.join('') + '</ul>',
              warning_flag ? common.errorLevels.Warning : common.errorLevels.Info,
              warning_flag ? 'Order toevoegen met waarschuwingen' : 'Order toevoegen',
              true
          )
        } // if - regels
        else {
          this.addLogBook(
              'Order heeft geen regels',
              common.errorLevels.Warning,
              'Order toevoegen',
              true
          )
        } // if - regels

        this.laatsteOrderSearchInput = null
      }  // if - menuItem

      this.laatsteOrderInProgress = false
    },

    dialogSettingsUnpack(data_settings) {
      // Lose optie naar 'options' lijst
      // Voordat dialog gaat openen

      // Copy object
      // var x = Object.hasOwn(Date, 'now') // Test

      let settings

      if (Array.isArray(data_settings)) {
        return [...data_settings]
      } else {
        settings = Object.assign({}, data_settings)
      }

      if (Object.hasOwn(settings, 'optionsNames')) {
        settings.options = []
        for (let i = 0; i < settings.optionsNames.length; i++) {
          const opName = settings.optionsNames[i]
          if (Object.hasOwn(settings, opName)) {
            // Is optie aan?
            if (settings[opName]) {
              settings.options.push(i)
            }
          }
        }
      } else if (Object.hasOwn(settings, 'options')) {
        console.warn(`dialogSettingsUnpack: Settings object ${settings} heeft geen 'optionsNames' element`)
      }
      return settings
    },

    dialogSettingsPack(data_settings) {
      // Option lijst naar losse options
      // Dialog save
      let settings

      if (Array.isArray(data_settings)) {
        return [...data_settings]
      } else {
        settings = Object.assign({}, data_settings)
      }

      if (Object.hasOwn(settings, 'optionsNames')) {
        for (let i = 0; i < settings.optionsNames.length; i++) {
          settings[settings.optionsNames[i]] = settings.options.includes(i)
        }
      } else if (Object.hasOwn(settings, 'options')) {
        console.warn(`dialogSettingsPack: Settings object ${settings} heeft geen 'optionsNames' element`)
      }
      return settings
    },

    /**
     * Bewerkt optie na Settings dialog te bewaren
     */
    m_saveSettingsDialog() {
      const dialog_suffix = 'Dialog'

      for (let prop_name in this.$data) {
        if (prop_name.search('settings') === 0 && Object.hasOwn(this.$data, prop_name + dialog_suffix)) {
          this[prop_name] = this.dialogSettingsPack(this[prop_name + dialog_suffix])
        }
      }

      // // Bedrijf
      // this.settingsBedrijf = this.dialogSettingsPack(this.settingsBedrijfDialog)
      // // Sjabloon
      // this.settingsSjabloon = this.dialogSettingsPack(this.settingsSjabloonDialog)
      // // Omzetgroepen
      // this.settingsOmzetgroepen = this.dialogSettingsPack(this.settingsOmzetgroepenDialog)
      // // Laatste orders filter
      // this.settingsLaatsteVerkooporders = this.dialogSettingsPack(this.settingsLaatsteVerkoopordersDialog)
      // // Order process status
      // this.settingsProcessStatus = this.dialogSettingsPack(this.settingsProcessStatusDialog)

      // Close dialog
      this.settingsDialogModel = false
    },

    /**
     * Open dialog met artikel
     */
    m_EditArtikelItem(item) {
      if (!this.ss_GetArtikelenProgress.loading) {
        // this.editedIndex = this.artikelenLocal.indexOf(item)
        this.editedIndex = this.comp_ArtikelenToolbarFilters.indexOf(item)
        this.editedItem = Object.assign({}, item)

        this.artikelDialog = true
      }
    },

    async m_ClearArtikelItem(item) {
      // this.editedIndex = this.artikelenLocal.indexOf(item)
      this.editedIndex = this.comp_ArtikelenToolbarFilters.indexOf(item)
      this.editedItem = Object.assign({}, item)

      this.editedItem.basket = null

      // Object.assign(this.comp_ArtikelenToolbarFilters[this.editedIndex], this.editedItem)
      await this.$store.dispatch('snelstart/WRITE_ARTIKEL_BUSKET_VALUE', {
        id: this.editedItem.id,
        value: this.editedItem.basket,
      })
      // this.basketCalc()
    },

    m_CleanBasket() {
      this.comp_ArtikelenInBasket.forEach(artikel => this.m_ClearArtikelItem(artikel))
      this.previewMode = false
    },

    /**
     * Plus 1 artikel in basket
     *   d888
     *  d8888
     *    888
     *    888     888
     *    888   8888888
     *    888     888
     *    888
     *  8888888
     */
    async m_PlusOneArtikel(item) {
      // this.editedIndex = this.artikelenLocal.indexOf(item)
      this.editedIndex = this.comp_ArtikelenToolbarFilters.indexOf(item)
      this.editedItem = Object.assign({}, item)

      this.editedItem.basket++

      // Object.assign(this.comp_ArtikelenToolbarFilters[this.editedIndex], this.editedItem)
      await this.$store.dispatch('snelstart/WRITE_ARTIKEL_BUSKET_VALUE', {
        id: this.editedItem.id,
        value: this.editedItem.basket,
      })
    },

    /**
     * Minus 1 artikel in basket
     *
     *        d888
     *       d8888
     *         888
     *         888
     *888888   888
     *         888
     *         888
     *       8888888
     */
    async m_MinOneArtikel(item) {
      if (item.basket >= 1) {
        // this.editedIndex = this.artikelenLocal.indexOf(item)
        this.editedIndex = this.comp_ArtikelenToolbarFilters.indexOf(item)
        this.editedItem = Object.assign({}, item)

        this.editedItem.basket--
        if (this.editedItem.basket === 0) {
          this.editedItem.basket = null
        }

        // Object.assign(this.comp_ArtikelenToolbarFilters[this.editedIndex], this.editedItem)
        await this.$store.dispatch('snelstart/WRITE_ARTIKEL_BUSKET_VALUE', {
          id: this.editedItem.id,
          value: this.editedItem.basket,
        })
      }
    },

    /**
     * Close Edit Artikel dialog (cancel)
     */
    m_CloseArtikelDialog() {
      this.artikelDialog = false
      this.editedItem.basket = null
      this.$nextTick(() => this.$refs.zoeken.focus())
    },

    /**
     * Save and Close dialog
     */
    async m_SaveArtikelDialog() {

      if (!isNaN(this.editedItem.basket)) {

        this.editedItem.basket = Number(this.editedItem.basket)

        if (this.editedItem.basket === 0) {
          this.editedItem.basket = null
        }

        if (this.editedIndex > -1) {
          console.log('write_art', this.editedItem)
          await this.$store.dispatch('snelstart/WRITE_ARTIKEL_BUSKET_VALUE', {
            id: this.editedItem.id,
            value: this.editedItem.basket,
          })
        }
        this.m_CloseArtikelDialog()
      }
    },

    /**
     * Order naar backend zenden
     *
     *
     **/
    async m_OrderZenden() {
      if (this.comp_ArtikelenInBasket.length === 0) {
        this.addLogBook(
            "Er zijn geen artikelen in winkelwagen",
            common.errorLevels.Warning,
            'Order Zenden',
            true
        )
        return
      }

      try {
        this.inProgressSend = true
        const order_uuid = uuidV4()
        const date_now = Date.now()

        const cur_operators = this.$store.getters['user/GET_CURRENT_OPERATORS'] || []
        if (cur_operators.length !== 1) {
          throw new Error(`${cur_operators.length} operator actief, moet één!`)
        }

        // nieuw order
        const order = {
          uuid: order_uuid,

          operator_name: 'WEB order',

          // TODO: DEBUG, operator ID definiëren
          // operator_id: this.$store.getters['app/GET_WEBORDER_OPERATOR_ID'],
          operator_id: cur_operators[0].id,

          snelstart: {
            // PK key van SnelStart administratie
            id: this.user_GetCurrentSnelStart.id,
            // Naam van SnelStart administratie
            naam: this.user_GetCurrentSnelStart.naam,
            // SnelStart Administratie UUID
            administratieIdentifier: this.user_GetCurrentSnelStart.bedrijf_info.administratieIdentifier,
          },

          user: {
            id: this.$store.getters['user/GET_CURRENT_PROFIEL'].id,
            username: this.$store.getters['user/GET_CURRENT_PROFIEL'].username,
          },

          order_relatie: {
            id: null,
            naam: '',
            uuid: '',
          },

          verzonden_op: date_now,
          verzonden_op_iso: new Date(date_now).toISOString(),

          processStatus: this.prop_ProcessStatusName,
          regels: [
            { // Schema
              uuid: null,
              artikelcode: '',
              omschrijving: null,
              // stuksprijs: null,
              aantal: null,
              // kortingsPercentage: 0.0,
              // totaal: 0.0
            },
          ],
          // Velden van verzend form
          memo: this.orderMemo,
          omschrijving: this.orderOmschrijving || this.settingsAlgemeen.defaultOrderOmschrijving,
          // Nu null
          orderreferentie: null,
          // Verkoopsjabloon
          verkoopordersjabloon: {
            id: this.currentSjabloonId,
            omschrijving: "Leeg",
            uuid: "00000000-0000-0000-0000-000000000000",
          },
          // Base64 encoded SVG signature
          signature: null,
          signatureSVG: null,
        }

        const {data: signData, isEmpty: isEmptySign} = this.$refs.signaturePad.saveSignature()

        if (!isEmptySign) {
          order.signature = signData
        }

        const {data: signDataSVG, isEmpty: isEmptySignSVG} = this.$refs.signaturePad.saveSignature("image/svg+xml")

        if (!isEmptySignSVG) {
          order.signatureSVG = signDataSVG
        }

        // Sjabloon kopiëren
        if (this.prop_CurrentSjabloonID) {
          const sjabloon = this.comp_FilteredSjablonen.find(i => i.id === this.prop_CurrentSjabloonID)

          if (sjabloon) {
            order.verkoopordersjabloon.id = sjabloon.id
            order.verkoopordersjabloon.omschrijving = sjabloon.omschrijving
            order.verkoopordersjabloon.uuid = sjabloon.uuid
          } else {
            throw new Error(`Sjabloon met id ${this.prop_CurrentSjabloonID} is niet gevonden`)
          }
        }
        // } else {
        //   throw 'Sjabloon is niet gekozen'
        // }

        // Bedrijf gegevens kopiëren
        // Één bedrijf in lijst, select hem
        if (this.comp_FilterKlantenMetConfiguratie.length === 1) {
          this.bedrijfLijstSelected = this.comp_FilterKlantenMetConfiguratie[0]
        }
        if (this.bedrijfLijstSelected) {
          // console.log(this.bedrijfLijstSelected)
          order.order_relatie.id = this.bedrijfLijstSelected.id
          order.order_relatie.naam = this.bedrijfLijstSelected.naam
          order.order_relatie.uuid = this.bedrijfLijstSelected.uuid
        } else {
          // this.addLogBook(
          //   'Order is niet geplaatst: Bedrijf/klant is niet gekozen',
          //   common.errorLevels.Error,
          //   'Order Zenden',
          //   true
          // )
          throw new Error('Bedrijf is niet gekozen')
        }

        order.regels = []
        this.comp_ArtikelenInBasket.forEach(regel => {
          order.regels.push({
            uuid: regel.uuid,
            artikelcode: regel.artikelcode,
            omschrijving: regel.omschrijving,
            aantal: regel.basket,
          })
        })

        // TODO: Operator zenden
        const uri = this.$store.getters['app/GET_URI_INZENDING']

        await this.$store.dispatch("user/REFRESH_TOKEN")
            .then((result) => {
              console.log('Nieuw token is aangevraagd...')
              console.dir(result)

              const config = this.$store.getters["user/GET_AXIOS_CONFIG"]

              // Stuur order met POST
              axios.post(
                  uri,
                  { // Inzending DATA
                    status: `Verzonden op ${new Date(order.verzonden_op).toLocaleString('NL', {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: '2-digit',
                      second: '2-digit'
                    })}`,
                    data: order,
                    operator: order.operator_id,
                  },
                  config)
                  // Post then
                  .then(value => {
                    if (value.status === 201) {
                      console.log("Order status:")

                      // TODO: Order uuid in de wachtrij voor status controle te zetten
                      // {
                      //    name
                      //    uuid
                      //    timestamp
                      //    status
                      // }
                      console.log("Order UUID:", order_uuid)
                      console.dir(value)

                      this.addLogBook(
                          'Order is gereed',
                          common.errorLevels.Info,
                          'Order is verzonden',
                          true
                      )
                      // ORDER IS VERSTUURT
                      this.orderOmschrijving = ''
                      this.orderMemo = ""
                      // TODO: moet Order sign ook schoongemaakt?
                      this.clearSignPad()

                      // Basket leg maken
                      this.m_CleanBasket()

                      // Zoekterm uit
                      this.search = ''

                    } else {
                      this.addLogBook(
                          `Order is niet geplaatst: ${value.statusText}`,
                          common.errorLevels.Error,
                          'Order Zenden',
                          true
                      )
                    }
                  })
                  // Post Catch
                  .catch(reason => {
                    this.addLogBook(
                        `Order is niet geplaatst: ${reason}`,
                        common.errorLevels.Error,
                        'Order Zenden',
                        true
                    )
                  })
            })
            // Token Catch
            .catch(reason => {
              this.addLogBook(
                  `Refresh token fout: ${reason}`,
                  common.errorLevels.Error,
                  'Order Zenden',
                  true
              )
              // throw reason
            })

        // Global try
      } catch (reason) {
        // console.log('Catch reason:')
        // console.dir(reason)
        this.addLogBook(
            reason.message,
            common.errorLevels.Error,
            'Order Zenden',
            true
        )
        // Global finally
      } finally {
        this.orderDialog = false
        console.log('Finally block')

        setTimeout(() => {
          this.inProgressSend = false
        }, 500)
      }
    },

    /**
     * Auto timer functie van VueTimers
     * @module Bestelling
     * @example
     * m_RunTimerUpdate() - test
     */
    async m_RunTimerUpdate() {
      console.log('Run: Timer');
      // console.log('Test:', this.comp_ProcessStatusListExcludeEmpty)
    },

    // Zij panel bericht
    addLogBook(text, level, titel, popUp = false) {
      common.fn.addMessage2Drawer(text, level, titel, 'Bestelling', popUp)
    },

    /**
     * Alle SnelStart gegevens voor bestel formulier laden
     *
     * @param forceLoad - altijd opnieuw lezen
     * @returns {Promise<void>}
     */
    async m_LoadSnelStartData(forceLoad = true) {
      this.inProgressLoad = true

      this.resetSelected()
      this.m_InitKlantSettingsGegevens()

      if (this.user_GetCurrentSnelStart) {
        const filteredArtikelsEmpty =
            this.ss_GetArtikelenLijst
                .filter(i => i.snelstart_id === this.user_GetCurrentSnelStart.id).length === 0

        const filteredSjablonenEmpty =
            this.ss_GetSjablonenLijst
                .filter(i => i.snelstart_id === this.user_GetCurrentSnelStart.id).length === 0

        const filteredKlantenEmpty =
            this.ss_GetKlantenLijst
                .filter(i => i.snelstart_id === this.user_GetCurrentSnelStart.id).length === 0

        const filteredVerkoopOrdersEmpty =
            this.comp_FilteredVerkoopOrders.length === 0

        // console.log('filteredArtikelsEmpty', filteredArtikelsEmpty)
        // console.log('filteredSjablonenEmpty', filteredSjablonenEmpty)
        // console.log('filteredKlantenEmpty', filteredVerkoopOrdersEmpty)
        // console.log('filteredVerkoopOrdersEmpty', filteredVerkoopOrdersEmpty)

        if (forceLoad
            || filteredArtikelsEmpty
            || filteredSjablonenEmpty
            || filteredVerkoopOrdersEmpty
            || filteredKlantenEmpty
        ) {
          // Lees artikelen opnieuw
          // const artikelAPI = `${this.rootURI}api/artikelen/?snelstart_id=${this.user_GetCurrentOperator.id}`
          this.$store.dispatch("user/REFRESH_TOKEN").then(() => {

            // ARTIKELEN
            // Lees artikelen, als lijst leeg of force reload
            if (filteredArtikelsEmpty || forceLoad) {
              this.$store.dispatch(
                  "snelstart/READ_ARTIKELEN_LIST",
                  {snelstart_id: this.user_GetCurrentSnelStart.id}
              )
                  .catch(e => {
                    this.addLogBook(
                        `Artikelen lezen fout ${e}`,
                        common.errorLevels.Error,
                        'Artikelen lezen',
                        true
                    )
                  })
                  .finally(() => {
                    this.inProgressSendOut()
                  })
            }

            // KLANTEN
            // Lees klanten, als lijst leeg of force reload
            this.bedrijfLijstSelected = null

            if (filteredKlantenEmpty || forceLoad) {
              this.$store.dispatch(
                  "snelstart/READ_KLANTEN_LIST",
                  {snelstart_id: this.user_GetCurrentSnelStart.id}
              )
                  .catch(e => {
                    this.addLogBook(
                        `Relaties lezen fout ${e}`,
                        common.errorLevels.Error,
                        'Relaties lezen',
                        true
                    )
                  })
                  .finally(() => {
                    this.inProgressSendOut()
                  })
            }

            // SJABLONEN
            // Lees sjablonen, als lijst leeg of force reload
            if (filteredSjablonenEmpty || forceLoad) {
              this.$store.dispatch(
                  "snelstart/READ_ORDER_SJABLONEN",
                  {snelstart_id: this.user_GetCurrentSnelStart.id}
              )
                  .catch(e => {
                    this.addLogBook(
                        `Order sjablonen lezen fout ${e}`,
                        common.errorLevels.Error,
                        'Verkooporder sjablonen lezen',
                        true
                    )
                  })
                  .finally(() => {
                    this.inProgressSendOut()
                  })
            }

            // VERKOOPORDER
            // Lees VerkoopOrders, als lijst leeg of force reload
            if (filteredVerkoopOrdersEmpty || forceLoad) {
              this.$store.dispatch(
                  "snelstart/READ_VERKOOP_ORDERS",
                  {snelstart_id: this.user_GetCurrentSnelStart.id}
              )
                  .catch(e => {
                    this.addLogBook(
                        `Verkooporders lezen fout ${e}`,
                        common.errorLevels.Error,
                        'Verkooporders lezen',
                        true
                    )
                  })
                  .finally(() => {
                    this.inProgressSendOut()
                  })
            }

          }).catch(e => {
            this.addLogBook(
                `Token refresh fout ${e}`,
                common.errorLevels.Error,
                'Access token refresh',
                true
            )
          }).finally(() => {
            this.inProgressSendOut()
          })
        }

        // preview optie uitschakelen
        this.previewMode = false
        this.currentSjabloonId = this.prop_CurrentSjabloonID

        // this.artikelenLocal = Object.assign([{basket: null}], this.artikelen.filter(i => i.snelstart_id === this.user_GetCurrentOperator.id))
        // // this.artikelenLocal.forEach(i => i.basket = null)
        // this.basketCalc()
      } else {
        this.addLogBook(
            'SnelStart administratie in niet gekozen',
            common.errorLevels.Warning,
            'loadArtikelen',
            true
        )
      }

      this.inProgressSendOut(700)
    },

    async m_loadVerkoopOrders() {
      console.log('Current SS is:', this.user_GetCurrentSnelStart.id)
      // Add Refresh token
      this.$store.dispatch(
          "snelstart/READ_VERKOOP_ORDERS",
          {snelstart_id: this.user_GetCurrentSnelStart.id}
      )
          .catch(e => {
            this.addLogBook(
                'Verkooporder lees fout: ' + e,
                common.errorLevels.Warning,
                'Lees Verkooporders',
                true
            )
          })
    },

    // Set vlag 'inProgressLoad' uit over 'timeOut' ms
    inProgressSendOut(timeOut = 500) {
      if (this.inProgressLoad) {
        setTimeout(() => this.inProgressLoad = false, timeOut)
      }
    },

    // Remove item van autocomplete lijst
    autocompleteRemove(id, selectedList) {
      return common.fn.autocompleteRemove(id, selectedList)
    },

    // Filter voor bedrijven
    bedrijfFilter(item, queryText, itemText) {
      // "Filteren kan met: relatiecode, naam, contactpersoon, postcode, straat, plaats en email"
      // console.log("item =", item)
      // console.log("query =", queryText)
      // console.log("tekst =", itemText)

      if (typeof queryText !== 'string' || typeof itemText !== 'string')
        return false

      const allText = `${itemText}
        ${item.relatiecode}
        ${item.vestigings_contactpersoon}
        ${item.vestigings_postcode}
        ${item.vestigings_straat}
        ${item.vestigings_plaats}
        ${item.email}`.toLowerCase()
      return allText.includes(queryText.toLowerCase())
    },

    // Reset alle selectie naar default
    resetSelected() {
      //Verkoop sjabloon
      this.currentSjabloonId = null

      // Reset selected Bedrijven
      this.settingsBedrijf.selected = []

    },

    // Kopie alle settings naar locale data
    m_InitKlantSettingsGegevens() {
      const init_suffix = '_Init'
      const conf_block = 'configuratie'

      // Alle data properties met suffix "_Init", kopiëren 'propName_Init' -> 'propName'
      for (let prop_name in this.$data) {
        if (Object.hasOwn(this.$data, prop_name + init_suffix)) {
          // let mObj=JSON.parse(JSON.stringify(jsonObject))
          this.$data[prop_name] = common.fn.deepCopy(this.$data[prop_name + init_suffix])
        }
      }

      // Alle .configuratie naar local data
      if (Object.hasOwn(this.comp_CurrentKlantgegevens, conf_block)) {
        const conf = this.comp_CurrentKlantgegevens[conf_block]

        // Unpack alle instellingen
        for (let conf_prop in conf) {

          // console.log('Props: ' + conf_prop)
          if (Object.hasOwn(this.$data, conf_prop + init_suffix)) {
            this.$data[conf_prop] = common.fn.deepCopy(
                Object.assign(
                    this.$data[conf_prop + init_suffix],
                    conf[conf_prop]
                )
            )
          } else {
            this.$data[conf_prop] = common.fn.deepCopy(conf[conf_prop])
            console.warn(`Configuratie [${conf_prop}_Init] is niet gevonden, gebruikt direct kopie`)
          }
        }
      }
    },

    m_getProcessStatusFromID(id) {
      // console.log("m_getProcessStatusFromID")
      // console.log(id)
      // console.log(this.processStatusListFilter.find(status => status.id === id))
      return this.processStatusListFilter.find(status => status.id === id)
    },

    m_getColorFromOmzetgroepID(id) {
      // Zoek index van omzetgroep

      // console.log(`m_getColorFromOmzetgroepID(${id}), this.comp_Omzetgroepen =`, this.comp_Omzetgroepen)

      let ind = this.comp_Omzetgroepen.findIndex(o => o.id === id)
      if (ind === -1) {
        return ''
      } else {
        const colorLen = this.colormap.paired.length
        ind = ind % colorLen
      }
      return this.colormap.paired[ind]
    },

    m_clearSelectedOmzetgroep() {
      this.$nextTick(() => this.prop_OmzetgroepID = 0)
    },

    m_getOmzetgroepenArtikelenCount(omzetgroep_id) {
      if (Array.isArray(this.comp_ArtikelenFromCurAdmWithFilter)) {
        if (omzetgroep_id === 0) {
          return this.comp_ArtikelenFromCurAdmWithFilter.length
        } else {
          return this.comp_ArtikelenFromCurAdmWithFilter.filter((i) => i.omzetgroep.id === omzetgroep_id).length
        }
      } else {
        return 0
      }
    },

    m_getArtikelenCountOpField(fieldName, item) {
      return this.comp_ArtikelenToolbarFiltersEnZoeken.filter((i) => i[fieldName] === item).length
      // return this.comp_ArtikelenFromCurAdm.filter((i) => i[fieldName] === item).length
    },

    async m_inputSearch() {
      // console.log("Enter in Search:", value)
      if (typeof this.search === 'string') {
        // if (val.length > 7) {
        let artikel = false

        // Artikelen tabel, zoeken met ref=""
        const vTable = this.$refs["main-artikel-table"].internalCurrentItems

        // Order zenden
        // TODO: code van instellingen ipv hardcoded
        if (this.search === this.orderEnterEANCode) {
          await this.m_OrderZenden()
          setTimeout(() => this.search = '', 0)

          // Zoeken in <v-table-data> object
        } else if (vTable.length === 1) {
          artikel = vTable[0]

          // Zoeken in alle artikelen van administratie
        } else {
          artikel = this.comp_ArtikelenFromCurAdmWithFilter.find(a => a.artikelcode === this.search)
        }

        // Artikel in order toevoegen
        if (artikel) {
          await this.m_PlusOneArtikel(artikel)
          setTimeout(() => this.search = '', 0)
        }
      }
    },

    async m_copy2Clipboard(data) {
      // console.log(`Copy 2 Clipboard: ${data}`)
      try {
        this.clipboardColor = ""
        this.clipboardMessage = "gekopieerd"
        await navigator.clipboard.writeText(data)
      } catch ($e) {
        this.clipboardColor = "error"
        this.clipboardMessage = "niet gelukt"
        console.log(`Kopie in Clipboard lukt niet: ${$e}`)
      }
      this.showClipboardMessage = true

      setTimeout(() => this.showClipboardMessage = false, 2000)
    },

    m_orderFocus2Memo() {
      // console.log('Focus 2 memo...')
      this.$nextTick(() => this.$refs['order-dialog-memo'].focus())
    },

    // Calc
    m_getVoorraadColor(item) {
      /*
      settingsVoorraadIndicator_Init: {
        show: false,            // Voorraad indicator aan
        label: "Vrd",
        default_red_level: 0,   // <= - RED
        default_green_level: 5, // >= - GREEN
        // red_level_extraveld: 'extra_velden_RedLevel',
        // green_level_extraveld: 'extra_velden_GreenLevel',
      }
      */

      const set_vi = this.settingsVoorraadIndicator
      const red_level = item[set_vi.red_level_extraveld] || set_vi.default_red_level || 0
      const green_level = item[set_vi.green_level_extraveld] || set_vi.default_green_level || 10

      if (item.vrije_voorraad <= red_level) {
        return 'error'
      } else if (item.vrije_voorraad >= green_level) {
        return 'success'
      } else {
        return 'warning'
      }
    },

    m_VerkoopOrdersInLastOrdersDialog_BlockCount(is_geblokkeerd) {
      /*
      Aantal orders in Laatste order dialog met block
       */
      return this.comp_VerkoopOrdersInLastOrdersDialogFiltered.filter(
          (i) => i?.get_meta?.geblokkeerd === is_geblokkeerd
      ).length
    },

    getRelatieFromID(relatie_id) {
      // return this.comp_RelatiesInLastOrdersDialog.find(
      return this.comp_KlantenCurAdm.find(
          i => i.id === relatie_id
      ) || {naam: '<Geen>'}
    },

    getOrderCountPerStatusID(status_id) {
      if (status_id === 0) {
        // console.log('Alle')
        // return this.comp_FilteredVerkoopOrders.length
        return this.comp_VerkoopOrdersInLastOrdersDialogFilteredExcludeStatus.length
      } else {
        // console.log('Status', status_id)
        // return this.comp_FilteredVerkoopOrders.filter(
        return this.comp_VerkoopOrdersInLastOrdersDialogFilteredExcludeStatus.filter(
            i => i.order_status === status_id
        ).length
      }
    },

    m_ArtikelenHoofdFormFilter(artikelen) {
      // console.log('m_ArtikelenHoofdFormFilter(artikelen), artikelen =', artikelen)
      // Filter moet uit in preview mode
      if (Array.isArray(artikelen) && Array.isArray(this.settingsFilterInToolbar.filters)) {
        //if (!this.previewMode) {
        for (let f of this.settingsFilterInToolbar.filters) {
          // Filter for multiselect
          if (Array.isArray(f.model)) {
            if (f.model.length > 0) {
              artikelen = artikelen.filter((art) => f.model.includes(art[f.fieldName]))
            }
          } else if (f.model !== null) {
            // Filter for single
            artikelen = artikelen.filter((art) => art[f.fieldName] === f.model)
          }
        }
        //}
        return artikelen
      }
      return Array.isArray(artikelen) ? artikelen : []
    },

    m_ArtikelenFieldFilter(artikelen) {
      const NAME = 0
      const OP = 1
      const VALUE = 2

      // const before_filter = artikelen

      if (Object.hasOwn(this.$data, 'settingsArtikelen')) {
        if (Object.hasOwn(this.settingsArtikelen, 'fieldFilters')) {
          if (Array.isArray(this.settingsArtikelen.fieldFilters)) {
            for (let flt of this.settingsArtikelen.fieldFilters) {

              // flt: ['field_name', 'operator', 'value']
              if (flt.length === 3) {
                const fieldName = flt[NAME]
                const operator = flt[OP]
                const value = flt[VALUE]

                switch (operator) {
                  case '=': // equal
                    artikelen = artikelen.filter(a => a[fieldName] === value)
                    break

                    // case '==': // equal
                    //   artikelen = artikelen.filter(a => a[fieldName] == value)
                    //   break

                  case '?=':  // equal or empty
                    artikelen = artikelen.filter(a => (a[fieldName] === value || !a[fieldName]))
                    break

                  case '>':   // great
                    artikelen = artikelen.filter(a => a[fieldName] > value)
                    break

                  case '<':   // less
                    artikelen = artikelen.filter(a => a[fieldName] < value)
                    break

                  case '>=':  // great or equal
                    artikelen = artikelen.filter(a => a[fieldName] >= value)
                    break

                  case '<=':  // less or equal
                    artikelen = artikelen.filter(a => a[fieldName] <= value)
                    break

                  case '!=':  // not equal
                    artikelen = artikelen.filter(a => a[fieldName] !== value)
                    break

                  case 'in':  // in list
                    artikelen = artikelen.filter(a => value.split(',').includes(a[fieldName]))
                    break

                  case '?in':  // in list or empty
                    artikelen = artikelen.filter(a => (!a[fieldName] || value.split(',').includes(a[fieldName])))
                    break

                  case 'not in':  // not in list
                    artikelen = artikelen.filter(a => !value.split(',').includes(a[fieldName]))
                    break

                  case 'true':  // is true
                    artikelen = artikelen.filter(a => !!a[fieldName])
                    break

                  case 'false': // is not true
                    artikelen = artikelen.filter(a => !a[fieldName])
                    break

                  case 'starts with': // string begin with
                    artikelen = artikelen.filter(a => String(a[fieldName]).startsWith(value))
                    break

                  case 'ends with':   // string end with
                    artikelen = artikelen.filter(a => String(a[fieldName]).endsWith(value))
                    break

                  case 'contains':    // string contain
                    artikelen = artikelen.filter(a => String(a[fieldName]).includes(value))
                    break

                  default:
                    console.error(`Operator "${operator}" is niet gevonden`)
                }
              } else {
                console.error('Filter options count != 3')
              }
            }
          }
        }
      }

      // if (artikelen.length === 0) {
      //   return before_filter
      // } else {
      return artikelen
      // }
    },

    // Lijst met alle zoekbare velden
    // Alle velden: comp_mainTableHeader
    // Exclude velden: settingsDisabledSearchFields
    m_searchFieldsList() {
      let sVelden = []

      // console.log('settingsDisabledSearchFields:')
      // console.dir(this.settingsDisabledSearchFields)
      // console.dir(Object.values(this.settingsDisabledSearchFields))

      for (const item of this.comp_mainTableHeader) {
        if (!(Object.values(this.settingsDisabledSearchFields).includes(item.value))) {
          // console.log('item=', item.value)
          sVelden.push(item.value)
        }
      }
      return sVelden
    },

    saveSignPad() {
      this.signData = this.$refs.signaturePad.toData()
    },

    clearSignPad() {
      if (!this.$refs.signaturePad.isEmpty()) {
        this.$refs.signaturePad.clearSignature()
      }
    },

    isEmptySignPad() {
      // console.log("isEmptySignPad:", this.$refs.signaturePad)
      try {
        return this.$refs.signaturePad.isEmpty()
      } catch {
        return true
      }
    },

    getControlGUIColor() {
      return this.$vuetify.theme.dark ? 'primary lighten-5' : 'primary'
    },

  }, // methods

  // MOUNTED
  mounted: function () {
    // Get init data
    console.log('MOUNT, SnelStart', this.user_GetCurrentSnelStart.naam)
    // this.$moment.locale('nl')
    // this.getAboData();
    this.m_LoadSnelStartData(false)
    // this.m_InitKlantSettingsGegevens()

    this.laatsteOrderDialogFilters.processStatus = this.processStatusListFilter[0]

  }, // mounted

  watch: {
    search(val) {
      // console.log('Search =', val)

      // Vorige timer loopt?
      if (this.searchTimeoutID !== null) {
        // Stop timer
        clearTimeout(this.searchTimeoutID)
        this.searchTimeoutID = null
      }

      this.searchTimeoutID = setTimeout(
          () => {
            this.searchDelay = val
            this.searchTimeoutID = null
          },
          (!val) ? 1 : 300
      )
    },

    basketCount(val) {
      // Reset preview if basket is empty
      this.previewMode = this.previewMode && !(val === 0)
    },

    // Reset zoekveld, als Preview aangepast
    previewMode() {
      this.search = ''
    },

    dialog(val) {
      val || this.m_CloseArtikelDialog()
    },

    settingsDialogModel(val) {
      // console.log('Setting Dialog', val)
      const dialog_suffix = 'Dialog'
      // Dialog gaat openen
      // Voel alle optie
      if (val) {
        for (let prop_name in this.$data) {
          if (prop_name.search('settings') === 0 && Object.hasOwn(this.$data, prop_name + dialog_suffix)) {
            this[prop_name + dialog_suffix] = this.dialogSettingsUnpack(this[prop_name])
          }
        }
        // // Bedrijf
        // this.settingsBedrijfDialog = this.dialogSettingsUnpack(this.settingsBedrijf)
        // // Sjabloon
        // this.settingsSjabloonDialog = this.dialogSettingsUnpack(this.settingsSjabloon)
        // // Omzetgroepen
        // this.settingsOmzetgroepenDialog = this.dialogSettingsUnpack(this.settingsOmzetgroepen)
        // // Process Status
        // this.settingsProcessStatusDialog = this.dialogSettingsUnpack(this.settingsProcessStatus)
      }
    },

    // Andere SnelStart gekozen
    user_GetCurrentOperator(val) {
      // user_GetCurrentOperator
      this.resetSelected()

      this.m_LoadSnelStartData(false).then(() => {
        // this.calcSelected()
        console.log("WATCHER: user_GetCurrentOperator -> loadSnelStartData.then()")
      })

      this.addLogBook(
          `${val.naam}`,
          common.errorLevels.Debug,
          'Andere SnelStart gekozen',
          false
      )
    },

    selectedRelatieIDInLastOrdersDialog() {
      // this.laatsteOrderDialogFilters.processStatusLijstModel = 0
    },

    //   wheel(val) {
    //     // console.dir(val)
    //     if (!isNaN(val.deltaY)) this.whellDeltaYSum += val.deltaY
    //     console.log('Time', val.timeStamp)
    //     console.log('X =', val.x)
    //     console.log('Y =', val.y)
    //     console.log('Delta Y =', val.deltaY)
    //     console.log('Delta Y Sum =', this.whellDeltaYSum)
    //   },
  }, // watch

  filters: {  // GEEN 'this' in deze sectie‼
    // Convert cijfer naar Euro formaat: 1000.9500 -> '€ 1.000,95'
    getEuro: function (value) {
      value = parseFloat(value)
      return value && typeof (value) == 'number' ? common.euroFilter.format(value) : null
    },
  } // filters
}
</script>

<style scoped>

.dialog-big-input {
  font-size: 1.8em;
}

#signature {
  border: double 2px transparent;
  border-radius: 5px;
  background-image: linear-gradient(#F6F5F4, #F1EEEB),
  radial-gradient(circle at top left, #F1DCBB, #E0C9A6);
  background-origin: border-box;
  background-clip: content-box, border-box;
  cursor: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg version='1.1' viewBox='0 0 512 512' xml:space='preserve' xmlns='http://www.w3.org/2000/svg'%3E%3Cpolygon points='393.29 213.66 142.44 464.52 87.044 424.95 345.82 150.36' fill='%230e5631'/%3E%3Cpolygon points='353.73 158.28 87.044 424.95 47.473 369.56 298.33 118.71' fill='%231ead64'/%3E%3Cpolygon points='512 94.965 440.78 166.18 377.48 118.71 464.52 47.486' fill='%23274d4b'/%3E%3Cpolygon points='464.52 47.482 385.38 126.62 345.82 71.224 417.04 2e-3' fill='%234f9b98'/%3E%3Crect transform='rotate(135)' x='-194.18' y='-429.18' width='67.156' height='134.29' fill='%23fa6105' stroke-width='.99999'/%3E%3Cpolygon points='71.22 488.26 0 512 23.736 440.78 63.305 448.69' fill='%23040609'/%3E%3Cpolygon points='47.473 369.56 23.736 440.78 71.22 488.26 142.44 464.52' fill='%23f2ebd9'/%3E%3Cg transform='rotate(45)' fill='%23f2ebd9' stroke-width='5.2016' aria-label='DKG'%3E%3Cpath d='m318.84-146.7h14.373q3.0987 0 5.4507-1.0453 2.352-1.0827 3.8453-2.8747 1.4933-1.8293 2.2027-4.032 0.70933-2.2027 0.70933-4.4427 0-2.3147-0.82133-4.6293-0.784-2.3147-2.464-4.2187t-4.3307-3.0613-6.1973-1.1573h-12.768zm8.9227-6.048v-13.365h2.3893q1.7547 0 2.9867 0.56 1.232 0.52267 1.9413 1.4933 0.74666 0.93334 1.0827 2.128 0.336 1.1573 0.336 2.5013 0 3.3973-1.568 5.04t-4.816 1.6427z'/%3E%3Cpath d='m349.98-146.7h8.9227v-11.909h0.0747l9.2213 11.909h10.64l-10.752-13.627 10.379-11.835h-9.3707l-10.192 11.536v-11.536h-8.9227z'/%3E%3Cpath d='m404.93-161.11h-10.005v5.376h3.1733v2.9867q-0.896 0.112-1.792 0.112-3.36 0-5.3013-1.792-1.9413-1.8293-1.9413-4.8907 0-3.248 2.128-5.2267 2.1653-2.016 5.6747-2.016 3.584 0 7.5787 2.1653v-6.384q-4.2933-1.7173-8.8853-1.7173-3.3973 0-6.2347 0.97066-2.8373 0.97067-4.8907 2.7627-2.0533 1.7547-3.1733 4.2187t-1.12 5.4133q0 2.24 0.784 4.48 0.82133 2.2027 2.576 4.1067 1.792 1.904 4.6293 3.0613 2.8747 1.1573 6.7947 1.1573 2.24 0 4.9653-0.336 2.7627-0.336 5.04-0.85866z'/%3E%3C/g%3E%3C/svg%3E%0A") 0 512, crosshair;
  /* 👇 PNG fallback */
  /* cursor: -webkit_image-set(url() 1x, url("") 2x) 0 0, pointer; */
  cursor: -webkit-image-set(
      url("data:image/png;base64,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") 1x,
      url("data:image/png;base64,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") 2x) 0 64, crosshair;
}

.custom-hide {
  color: #777777;
}

/*.theme--light.v-data-table tbody tr:nth-of-type(even) {*/
/*    background-color: rgba(0, 0, 0, .3);*/
/*}*/
/*.theme--dark.v-data-table tbody tr:nth-of-type(even) {*/
/*    background-color: rgba(0, 0, 0, .05);*/
/*}*/
</style>
